<template>
  <div>
    <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
      <div class="single container-max page-content kms-pdp-shell">
        <div class="kms-pdp__main">
          <div class="kms-pdp__left">
            <section class="kms-pdp__media">
              <div v-if="productTags.length" class="kms-pdp__tag-list kms-pdp__tag-list--media">
                <span v-for="tag in productTags" :key="tag.id || getTagName(tag)" class="kms-pdp__product-tag">
                  {{ getTagName(tag) }}
                </span>
              </div>
              <slot name="image-carousel"></slot>
            </section>

          <section class="kms-pdp__information">
            <!-- ITEM DESCRIPTION -->
            <div class="kms-pdp__tabs">
              <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item" v-if="isDescriptionTabActive">
                  <a class="nav-link active" data-toggle="tab" :href="'#details-' + currentVariation.variation.id" role="tab">{{ $translate("Ceres::Template.singleItemDescription") }}</a>
                </li>

                <li class="nav-item" v-if="isTechnicalDataTabActive">
                  <a
                    :class="{
                      active: !isDescriptionTabActive && isTechnicalDataTabActive,
                    }"
                    class="nav-link"
                    data-toggle="tab"
                    :href="'#data-' + currentVariation.variation.id"
                    role="tab"
                    >{{ $translate("Ceres::Template.singleItemTechnicalData") }}</a
                  >
                </li>

                <li class="nav-item">
                  <a
                    :class="{
                      active: !isDescriptionTabActive && !isTechnicalDataTabActive,
                    }"
                    class="nav-link"
                    data-toggle="tab"
                    href="#assessments-details"
                    role="tab"
                    >{{ $translate("Ceres::Template.singleItemMoreDetails") }}</a
                  >
                </li>

                <li class="nav-item downloads" v-if="currentVariation.variationProperties && currentVariation.variationProperties.length > 0">
                  <a class="nav-link" data-toggle="tab" href="#downloads" role="tab">Downloads</a>
                </li>
                <li class="nav-item" v-if="isEuResponsibleTabShown">
                  <a class="nav-link" data-toggle="tab" href="#eu-responsible" role="tab">{{ $translate("Ceres::Template.singleItemEuResponsiblePerson") }}</a>
                </li>

                <li class="nav-item" v-if="isManufacturerTabShown">
                  <a class="nav-link" data-toggle="tab" href="#manufacturer" role="tab">{{ $translate("Ceres::Template.singleItemManufacturer") }}</a>
                </li>

                <li class="nav-item">
                  <a class="nav-link" data-toggle="tab" href="#savety" role="tab">{{ $translate("KMSVueTheme::SingleItemTheme.SavetyTab") }}</a>
                </li>

                <slot name="add-detail-tabs"></slot>
              </ul>

              <div class="tab-content overflow-hidden">
                <div class="tab-pane active overflow-auto" :id="'details-' + currentVariation.variation.id" role="tabpanel" v-if="isDescriptionTabActive">
                  <div class="my-4" v-html="currentVariation.texts.description"></div>
                </div>

                <div
                  :class="{
                    active: !isDescriptionTabActive && isTechnicalDataTabActive,
                  }"
                  class="tab-pane overflow-auto"
                  :id="'data-' + currentVariation.variation.id"
                  role="tabpanel"
                  v-if="isTechnicalDataTabActive"
                >
                  <div class="my-4" v-html="currentVariation.texts.technicalData"></div>
                </div>

                <div
                  :class="{
                    active: !isDescriptionTabActive && !isTechnicalDataTabActive,
                  }"
                  class="tab-pane overflow-auto"
                  id="assessments-details"
                  role="tabpanel"
                >
                  <div class="my-4">
                    <table class="table table-striped table-hover table-sm">
                      <tbody>
                        <tr v-if="itemConfig.includes('item.id') || itemConfig.includes('all')">
                          <td>
                            {{ $translate("Ceres::Template.singleItemId") }}
                          </td>
                          <td>{{ currentVariation.item.id }}</td>
                        </tr>

                        <tr v-if="currentVariation.item.condition && currentVariation.item.condition.names.name !== '' && (itemConfig.includes('item.condition') || itemConfig.includes('all'))">
                          <td>
                            {{ $translate("Ceres::Template.singleItemCondition") }}
                          </td>
                          <td>
                            {{ currentVariation.item.condition.names.name }}
                          </td>
                        </tr>

                        <tr v-if="itemConfig.includes('item.age_rating') || itemConfig.includes('all')">
                          <td>
                            {{ $translate("Ceres::Template.singleItemAge") }}
                          </td>
                          <td>
                            {{ currentVariation.item.ageRestriction | ageRestriction }}
                          </td>
                        </tr>

                        <tr v-if="currentVariation.variation.externalId !== '' && (itemConfig.includes('item.external_id') || itemConfig.includes('all'))">
                          <td>
                            {{ $translate("Ceres::Template.singleItemExternalVariationId") }}
                          </td>
                          <td>{{ currentVariation.variation.externalId }}</td>
                        </tr>

                        <tr v-if="currentVariation.variation.model !== '' && (itemConfig.includes('item.variation_model') || itemConfig.includes('all'))">
                          <td>
                            {{ $translate("Ceres::Template.singleItemModel") }}
                          </td>
                          <td>{{ currentVariation.variation.model }}</td>
                        </tr>

                        <tr
                          v-if="
                            currentVariation.filter.hasManufacturer &&
                              currentVariation.item.manufacturer.externalName !== '' &&
                              (itemConfig.includes('item.manufacturer') || itemConfig.includes('all'))
                          "
                        >
                          <td>
                            {{ $translate("Ceres::Template.singleItemManufacturer") }}
                          </td>
                          <td>
                            {{ currentVariation.item.manufacturer.externalName }}
                          </td>
                        </tr>

                        <tr
                          v-if="
                            currentVariation.item.producingCountry &&
                              currentVariation.item.producingCountry.names.name !== '' &&
                              (itemConfig.includes('item.producerCountry') || itemConfig.includes('all'))
                          "
                        >
                          <td>
                            {{ $translate("Ceres::Template.singleItemManufacturingCountry") }}
                          </td>
                          <td>
                            {{ currentVariation.item.producingCountry.names.name }}
                          </td>
                        </tr>

                        <tr v-if="currentVariation.unit && (itemConfig.includes('item.variationBase_content') || itemConfig.includes('all'))">
                          <td>
                            {{ $translate("Ceres::Template.singleItemContent") }}
                          </td>
                          <td>
                            {{ currentVariation.unit.content }}
                            {{ currentVariation.unit.names.name }}
                          </td>
                        </tr>

                        <tr v-if="currentVariation.variation.weightG !== '' && (itemConfig.includes('item.weightG') || itemConfig.includes('all'))">
                          <td>
                            {{ $translate("Ceres::Template.singleItemWeight") }}
                          </td>
                          <td>{{ currentVariation.variation.weightG }} g</td>
                        </tr>

                        <tr v-if="currentVariation.variation.weightNetG !== '' && (itemConfig.includes('item.weightNetG') || itemConfig.includes('all'))">
                          <td>
                            {{ $translate("Ceres::Template.singleItemNetWeight") }}
                          </td>
                          <td>{{ currentVariation.variation.weightNetG }} g</td>
                        </tr>

                        <tr v-if="itemConfig.includes('item.variation_dimensions') || itemConfig.includes('all')">
                          <td>
                            {{ $translate("Ceres::Template.singleItemDimensions") }}
                          </td>
                          <td>
                            <span>{{ currentVariation.variation.lengthMM }}</span
                            >&times;<!--
                                                  --><span>{{ currentVariation.variation.widthMM }}</span
                            >&times;<!--
                                                  --><span>{{ currentVariation.variation.heightMM }}</span>
                            mm
                          </td>
                        </tr>

                        <tr v-if="currentVariation.variation.customsTariffNumber !== '' && (itemConfig.includes('variation.customs_tariff_number') || itemConfig.includes('all'))">
                          <td>
                            {{ $translate("Ceres::Template.singleItemCustomsTariffNumber") }}
                          </td>
                          <td>
                            {{ currentVariation.variation.customsTariffNumber }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="tab-pane overflow-auto" id="downloads" role="tabpanel">
                  <!-- Überprüfen, ob 'variationProperties' existiert und die erste Eigenschaft 'id' 2 hat -->
                  <div class="downloads my-4" v-if="currentVariation.variationProperties && currentVariation.variationProperties.length > 0">
                    <template v-for="(variationProperty, variationIndex) in currentVariation.variationProperties" v-if="variationProperty.id === 2">
                      <!-- Schleife durch die Eigenschaften innerhalb der Gruppe mit der ID 2 -->
                      <div class="mt-3" v-for="(property, index) in variationProperty.properties" :key="index">
                        <a :href="property.values.value" target="_blank" class="d-inline-flex text-left flex-column-reverse">
                          <span class="color-dark mt-2 font-weight-bold">
                            {{ property.names.name }}
                          </span>
                          <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
                        </a>
                      </div>
                    </template>
                  </div>
                </div>

                <div class="tab-pane overflow-auto" id="eu-responsible" role="tabpanel" v-if="isEuResponsibleTabShown">
                  <div class="my-4">
                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsibleName }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsibleStreet }}</span>
                      <span>{{ currentVariation.item.manufacturer.responsibleHouseNo }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsiblePostCode }}</span>
                      <span>{{ currentVariation.item.manufacturer.responsibleTown }}</span>
                      <span v-if="currentVariation.item.manufacturer.responsibleCountryObject">
                        {{ currentVariation.item.manufacturer.responsibleCountryObject.name }}
                      </span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsibleEmail }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsiblePhoneNo }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsibleContactUrl }}</span>
                    </div>
                  </div>
                </div>

                <div class="tab-pane overflow-auto" id="manufacturer" role="tabpanel" v-if="isManufacturerTabShown">
                  <div class="my-4">
                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.name }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.legalName }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.street }}</span>
                      <span>{{ currentVariation.item.manufacturer.houseNo }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.postcode }}</span>
                      <span>{{ currentVariation.item.manufacturer.town }}</span>
                      <span v-if="currentVariation.item.manufacturer.countryObject">
                        {{ currentVariation.item.manufacturer.countryObject.name }}
                      </span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.email }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.url }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.phoneNumber }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.faxNumber }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.contactUrl }}</span>
                    </div>
                  </div>
                </div>

                <div class="tab-pane overflow-auto" id="savety" role="tabpanel">
                  <div class="my-4">
                    <div class="p-0">
                      <div id="accordion_67921b7679be1" class="widget widget-accordion widget-none">
                        <div class="card">
                          <button
                            id="heading_67921b7679be1_1"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapse_67921b7679be1_1"
                            aria-expanded="false"
                            aria-controls="collapse_67921b7679be1_1"
                            class="card-header btn btn-link text-appearance collapsed "
                          >
                            <h5 class="h5 pr-5 mb-0">
                              Deutsch
                              <i class="fa fa-chevron-down"></i>
                            </h5>
                          </button>
                          <div id="collapse_67921b7679be1_1" aria-labelledby="heading_67921b7679be1_1" data-parent="#accordion_67921b7679be1" class="collapse">
                            <div class="card-body">
                              <p id="isPasted"><strong>Produktsicherheitshinweis</strong></p>
                              <p><strong>&nbsp;</strong></p>
                              <p>
                                Ihre Sicherheit steht bei uns an erster Stelle. Unsere Produkte entsprechen den Anforderungen der EU-Produktsicherheitsverordnung (EU) 2023/988 und erfüllen höchste
                                Sicherheits- und Qualitätsstandards für die Gewährleistung eines reibungslosen Geräte-Betriebs.
                              </p>
                              <p>&nbsp;</p>
                              <p><strong>Unsere Verpflichtungen zur Produktsicherheit</strong></p>
                              <p><br />Einhaltung von EU-Richtlinien:</p>
                              <p>Alle unsere Produkte werden gemäß den geltenden Sicherheits- und Gesundheitsvorschriften entwickelt und getestet.</p>
                              <p>&nbsp;</p>
                              <p>Risikobewertung und Qualität:</p>
                              <p>Jedes Produkt durchläuft umfassende Prüfverfahren, um maximale Sicherheit und Funktionalität zu gewährleisten.</p>
                              <p>&nbsp;</p>
                              <p>Sicherheitsinformationen:</p>
                              <p>Unsere Produkte werden mit detaillierten Anleitungen und Sicherheitsvorgaben geliefert, die unbedingt vor der Nutzung zu lesen und zu befolgen sind.</p>
                              <p>&nbsp;</p>
                              <p>
                                <strong>Wichtige Hinweise für die sichere Nutzung<br /></strong>
                              </p>
                              <p><strong>Original-Ersatzteile verwenden:</strong></p>
                              <p>
                                Wir empfehlen dringend, ausschließlich Original-Ersatzteile zu verwenden. Der Einsatz nicht geprüfter Teile kann die Sicherheit und Funktionstüchtigkeit des Geräts
                                beeinträchtigen.
                              </p>
                              <p>&nbsp;</p>
                              <p><strong>Keine Manipulation oder Zweckentfremdung:</strong></p>
                              <p>Bitte verändern oder manipulieren Sie das Gerät nicht manuell und verwenden Sie es nur entsprechend der vorgesehenen Bestimmung.</p>
                              <p>&nbsp;</p>
                              <p><strong>Vom Stromnetz trennen:</strong></p>
                              <p>Falls Wartungsarbeiten erforderlich sind, stellen Sie sicher, dass das Gerät vollständig vom Stromnetz getrennt ist, um elektrische Gefahren auszuschließen.</p>
                              <p>&nbsp;</p>
                              <p><strong>Gebrauchsanleitung beachten:</strong></p>
                              <p>
                                Folgen Sie stets den Anweisungen in der Benutzerhandbuch oder Gebrauchsanleitung des Herstellers. Abweichungen können zu Fehlfunktionen oder Sicherheitsrisiken führen.
                              </p>
                              <p>&nbsp;</p>
                              <p><strong>Technischen Kundenservice kontaktieren:</strong></p>
                              <p>Im Zweifelsfall oder bei Problemen mit Ihrem Gerät steht unser technischer Kundenservice bereit, um Sie kompetent zu unterstützen.</p>
                              <p>&nbsp;</p>
                              <p><strong>Ihre Verantwortung als Nutzer:</strong></p>
                              <p>Lesen und verstehen Sie alle Sicherheits- und Bedienungshinweise sorgfältig.</p>
                              <p>Nutzen Sie das Gerät ausschließlich in der vorgesehenen Weise und Umgebung.</p>
                              <p>Bewahren Sie das Gerät sicher auf und außerhalb der Reichweite von Kindern, sofern es nicht ausdrücklich für deren Nutzung bestimmt ist.</p>
                              <p>&nbsp;</p>
                              <p><strong>Kontakt zu unserem Kundenservice:</strong></p>
                              <p>Für Unterstützung oder Rückfragen stehen wir Ihnen jederzeit zur Verfügung:</p>
                              <p><br />E-Mail: kundenservice@kms-handel.de</p>
                              <p>Telefon: +49 5921 81 999 - 0</p>
                              <p>&nbsp;</p>
                              <p>
                                Ihr Vertrauen ist unsere Verantwortung. Mit unseren Produkten und Ihrem sicheren Umgang sorgen wir gemeinsam dafür, dass Sie hochwertige Unterhaltung sorgenfrei
                                genießen können.
                              </p>
                              <p>&nbsp;</p>
                            </div>
                          </div>
                        </div>
                        <div class="card">
                          <button
                            id="heading_67921b7679be1_2"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapse_67921b7679be1_2"
                            aria-expanded="false"
                            aria-controls="collapse_67921b7679be1_2"
                            class="card-header btn btn-link text-appearance collapsed "
                          >
                            <h5 class="h5 pr-5 mb-0">
                              English
                              <i class="fa fa-chevron-down"></i>
                            </h5>
                          </button>
                          <div id="collapse_67921b7679be1_2" aria-labelledby="heading_67921b7679be1_2" data-parent="#accordion_67921b7679be1" class="collapse">
                            <div class="card-body">
                              <p id="isPasted"><strong>Product Safety Notice</strong></p>
                              <p>
                                Your safety is our top priority. Our products comply with the requirements of the EU Product Safety Regulation (EU) 2023/988 and meet the highest safety and quality
                                standards to ensure smooth device operation.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Our Commitments to Product Safety</strong></p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Compliance with EU Directives:</strong> <br />All our products are developed and tested in accordance with applicable safety and health regulations.</p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Risk Assessment and Quality:</strong> <br />Every product undergoes comprehensive testing procedures to ensure maximum safety and functionality.</p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Safety Information:</strong> <br />Our products are delivered with detailed instructions and safety guidelines, which must be read and followed before use.</p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Important Notes for Safe Use</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Use Original Spare Parts:</strong> <br />We strongly recommend using only original spare parts. The use of untested parts can compromise the safety and
                                functionality of the device.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>No Tampering or Misuse:</strong> <br />Please do not manually modify or tamper with the device and use it only as intended.</p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Disconnect from the Power Supply:</strong> <br />If maintenance is required, ensure the device is completely disconnected from the power supply to eliminate
                                electrical hazards.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Follow the User Manual:</strong> <br />Always adhere to the instructions in the user manual or operating guide provided by the manufacturer. Deviations may
                                result in malfunctions or safety risks.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Contact Technical Customer Service:</strong> <br />If in doubt or if you encounter any issues with your device, our technical customer service team is available
                                to assist you competently.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Your Responsibility as a User</strong></p>
                              <ul>
                                <li>Carefully read and understand all safety and operating instructions.</li>
                                <li>Use the device only in the intended manner and environment.</li>
                                <li>Store the device securely and out of reach of children unless explicitly designed for their use.</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p><strong>Contact Our Customer Service</strong></p>
                              <p>For support or inquiries, we are always available to assist you:</p>
                              <ul>
                                <li><strong>Email:</strong> kundenservice@kms-handel.de</li>
                                <li><strong>Phone:</strong> +49 5921 81 999 - 0</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p>Your trust is our responsibility. Together, with our products and your safe handling, we ensure that you can enjoy high-quality entertainment worry-free.</p>
                            </div>
                          </div>
                        </div>
                        <div class="card">
                          <button
                            id="heading_67921b7679be1_3"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapse_67921b7679be1_3"
                            aria-expanded="false"
                            aria-controls="collapse_67921b7679be1_3"
                            class="card-header btn btn-link text-appearance collapsed "
                          >
                            <h5 class="h5 pr-5 mb-0">
                              Français
                              <i class="fa fa-chevron-down"></i>
                            </h5>
                          </button>
                          <div id="collapse_67921b7679be1_3" aria-labelledby="heading_67921b7679be1_3" data-parent="#accordion_67921b7679be1" class="collapse">
                            <div class="card-body">
                              <p id="isPasted"><strong>Avis de sécurité des produits</strong></p>
                              <p>
                                Votre sécurité est notre priorité absolue. Nos produits sont conformes aux exigences du Règlement de sécurité des produits de l'UE (UE) 2023/988 et répondent aux normes
                                de sécurité et de qualité les plus élevées pour garantir un fonctionnement sans faille de vos appareils.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Nos engagements en matière de sécurité des produits</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Conformité aux directives européennes :</strong> <br />Tous nos produits sont développés et testés conformément aux réglementations en vigueur en matière de
                                sécurité et de santé.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Évaluation des risques et qualité :</strong> <br />Chaque produit est soumis à des procédures de tests approfondies afin de garantir une sécurité et une
                                fonctionnalité maximales.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Informations de sécurité :</strong> <br />Nos produits sont livrés avec des instructions détaillées et des consignes de sécurité, qui doivent être lues et
                                respectées avant toute utilisation.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Consignes importantes pour une utilisation en toute sécurité</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Utiliser des pièces de rechange d'origine :</strong> <br />Nous recommandons vivement d'utiliser uniquement des pièces de rechange d'origine. L'utilisation de
                                pièces non testées peut compromettre la sécurité et le bon fonctionnement de l'appareil.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Ne pas modifier ni détourner l'usage prévu:</strong> <br />Veuillez ne pas modifier ou manipuler l'appareil manuellement et l'utiliser uniquement selon l'usage
                                prévu.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Débrancher l'appareil :</strong> <br />En cas de travaux de maintenance, assurez-vous que l'appareil est entièrement déconnecté du réseau électrique afin
                                d'éliminer tout risque électrique.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Suivre le mode d'emploi :</strong> <br />Respectez toujours les instructions du manuel ou du guide d'utilisation fourni par le fabricant. Toute déviation peut
                                entraîner des dysfonctionnements ou des risques pour la sécurité.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Contacter le service clientèle technique :</strong> <br />En cas de doute ou de problème avec votre appareil, notre service clientèle technique est disponible
                                pour vous offrir une assistance compétente.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Votre responsabilité en tant qu’utilisateur</strong></p>
                              <ul>
                                <li>Lisez attentivement et comprenez toutes les consignes de sécurité et d'utilisation.</li>
                                <li>Utilisez l'appareil uniquement de manière appropriée et dans l'environnement prévu.</li>
                                <li>Rangez l'appareil en toute sécurité et hors de portée des enfants, sauf s'il est explicitement conçu pour leur usage.</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p><strong>Contactez notre service clientèle</strong></p>
                              <p>Pour toute assistance ou question, nous sommes toujours à votre disposition :</p>
                              <ul>
                                <li><strong>E-mail :</strong> kundenservice@kms-handel.de</li>
                                <li><strong>Téléphone :</strong> +49 5921 81 999 - 0</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p>
                                Votre confiance est notre responsabilité. Avec nos produits et votre utilisation en toute sécurité, nous veillons ensemble à ce que vous puissiez profiter pleinement de
                                divertissements de qualité en toute sérénité.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="card">
                          <button
                            id="heading_67921b7679be1_4"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapse_67921b7679be1_4"
                            aria-expanded="false"
                            aria-controls="collapse_67921b7679be1_4"
                            class="card-header btn btn-link text-appearance collapsed "
                          >
                            <h5 class="h5 pr-5 mb-0">
                              Italiano
                              <i class="fa fa-chevron-down"></i>
                            </h5>
                          </button>
                          <div id="collapse_67921b7679be1_4" aria-labelledby="heading_67921b7679be1_4" data-parent="#accordion_67921b7679be1" class="collapse">
                            <div class="card-body">
                              <p id="isPasted"><strong>Avviso di sicurezza del prodotto</strong></p>
                              <p>
                                La vostra sicurezza è la nostra priorità assoluta. I nostri prodotti sono conformi ai requisiti del Regolamento sulla sicurezza dei prodotti dell'UE (UE) 2023/988 e
                                rispettano i più alti standard di sicurezza e qualità per garantire un funzionamento regolare dei dispositivi.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>I nostri impegni per la sicurezza del prodotto</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Conformità alle direttive UE:</strong> <br />Tutti i nostri prodotti sono sviluppati e testati in conformità con le normative vigenti in materia di sicurezza e
                                salute.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Valutazione dei rischi e qualità:</strong> <br />Ogni prodotto è sottoposto a procedure di test approfondite per garantire la massima sicurezza e funzionalità.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Informazioni sulla sicurezza:</strong> <br />I nostri prodotti sono forniti con istruzioni dettagliate e linee guida di sicurezza che devono essere lette e
                                seguite prima dell'uso.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Indicazioni importanti per un utilizzo sicuro</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Utilizzare solo ricambi originali:</strong> <br />Raccomandiamo vivamente di utilizzare esclusivamente ricambi originali. L'uso di componenti non testati può
                                compromettere la sicurezza e il funzionamento del dispositivo.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Non modificare o usare impropriamente il dispositivo:</strong> <br />Si prega di non modificare manualmente il dispositivo e di utilizzarlo solo per l'uso
                                previsto.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Scollegare dalla rete elettrica:</strong> <br />In caso di interventi di manutenzione, assicurarsi che il dispositivo sia completamente scollegato dalla rete
                                elettrica per evitare rischi elettrici.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Seguire il manuale d'uso:</strong> <br />Attenersi sempre alle istruzioni fornite nel manuale d'uso o nella guida del produttore. Eventuali deviazioni possono
                                causare malfunzionamenti o rischi per la sicurezza.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Contattare il servizio clienti tecnico:</strong> <br />In caso di dubbi o problemi con il dispositivo, il nostro servizio clienti tecnico è a disposizione per
                                offrirvi assistenza competente.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>La vostra responsabilità come utente</strong></p>
                              <ul>
                                <li>Leggete attentamente e comprendete tutte le istruzioni di sicurezza e di utilizzo.</li>
                                <li>Utilizzate il dispositivo esclusivamente in modo appropriato e nell'ambiente previsto.</li>
                                <li>Conservate il dispositivo in modo sicuro e fuori dalla portata dei bambini, salvo diversa indicazione per il loro utilizzo.</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p><strong>Contattare il nostro servizio clienti</strong></p>
                              <p>Per assistenza o domande, siamo sempre a vostra disposizione:</p>
                              <ul>
                                <li><strong>E-mail:</strong> kundenservice@kms-handel.de</li>
                                <li><strong>Telefono:</strong> +49 5921 81 999 - 0</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p>
                                La vostra fiducia è la nostra responsabilità. Con i nostri prodotti e il vostro utilizzo sicuro, garantiamo insieme che possiate godere di un intrattenimento di alta
                                qualità senza preoccupazioni.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="card">
                          <button
                            id="heading_67921b7679be1_5"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapse_67921b7679be1_5"
                            aria-expanded="false"
                            aria-controls="collapse_67921b7679be1_5"
                            class="card-header btn btn-link text-appearance collapsed "
                          >
                            <h5 class="h5 pr-5 mb-0">
                              Nederlands
                              <i class="fa fa-chevron-down"></i>
                            </h5>
                          </button>
                          <div id="collapse_67921b7679be1_5" aria-labelledby="heading_67921b7679be1_5" data-parent="#accordion_67921b7679be1" class="collapse">
                            <div class="card-body">
                              <p id="isPasted"><strong>Productveiligheidswaarschuwing</strong></p>
                              <p>
                                Uw veiligheid staat bij ons op de eerste plaats. Onze producten voldoen aan de eisen van de EU-verordening productveiligheid (EU) 2023/988 en voldoen aan de hoogste
                                veiligheids- en kwaliteitsnormen om een probleemloze werking van de apparaten te garanderen.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Onze verplichtingen op het gebied van productveiligheid</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Naleving van EU-richtlijnen:</strong> <br />Al onze producten worden ontwikkeld en getest in overeenstemming met de geldende veiligheids- en
                                gezondheidsvoorschriften.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Risicobeoordeling en kwaliteit:</strong> <br />Elk product ondergaat uitgebreide testprocedures om maximale veiligheid en functionaliteit te waarborgen.</p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Veiligheidsinformatie:</strong> <br />Onze producten worden geleverd met gedetailleerde handleidingen en veiligheidsrichtlijnen die vóór gebruik zorgvuldig
                                moeten worden gelezen en opgevolgd.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Belangrijke aanwijzingen voor veilig gebruik</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Gebruik originele reserveonderdelen:</strong> <br />Wij raden sterk aan uitsluitend originele reserveonderdelen te gebruiken. Het gebruik van niet-geteste
                                onderdelen kan de veiligheid en functionaliteit van het apparaat in gevaar brengen.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Geen manipulatie of oneigenlijk gebruik:</strong> <br />Wijzig of manipuleer het apparaat niet handmatig en gebruik het uitsluitend volgens de voorgeschreven
                                doeleinden.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Loskoppelen van het stroomnet:</strong> <br />Zorg er bij onderhoudswerkzaamheden voor dat het apparaat volledig is losgekoppeld van het stroomnet om
                                elektrische gevaren te voorkomen.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Houd u aan de gebruiksaanwijzing:</strong> <br />Volg altijd de instructies in de handleiding of gebruiksaanwijzing van de fabrikant. Afwijkingen hiervan kunnen
                                leiden tot storingen of veiligheidsrisico’s.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Neem contact op met de technische klantenservice:</strong> <br />Bij twijfel of problemen met uw apparaat staat onze technische klantenservice klaar om u
                                deskundig te ondersteunen.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Uw verantwoordelijkheid als gebruiker</strong></p>
                              <ul>
                                <li>Lees en begrijp alle veiligheids- en bedieningsinstructies zorgvuldig.</li>
                                <li>Gebruik het apparaat uitsluitend op de voorgeschreven wijze en in de daarvoor bedoelde omgeving.</li>
                                <li>Bewaar het apparaat op een veilige plaats en buiten bereik van kinderen, tenzij het uitdrukkelijk is bedoeld voor gebruik door hen.</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p><strong>Contact met onze klantenservice</strong></p>
                              <p>Voor ondersteuning of vragen staan wij altijd tot uw beschikking:</p>
                              <ul>
                                <li><strong>E-mail:</strong> kundenservice@kms-handel.de</li>
                                <li><strong>Telefoon:</strong> +49 5921 81 999 - 0</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p>
                                Uw vertrouwen is onze verantwoordelijkheid. Samen zorgen we, met onze producten en uw veilige gebruik, ervoor dat u zorgeloos kunt genieten van hoogwaardige
                                entertainment.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="card">
                          <button
                            id="heading_67921b7679be1_6"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapse_67921b7679be1_6"
                            aria-expanded="false"
                            aria-controls="collapse_67921b7679be1_6"
                            class="card-header btn btn-link text-appearance collapsed "
                          >
                            <h5 class="h5 pr-5 mb-0">
                              Български
                              <i class="fa fa-chevron-down"></i>
                            </h5>
                          </button>
                          <div id="collapse_67921b7679be1_6" aria-labelledby="heading_67921b7679be1_6" data-parent="#accordion_67921b7679be1" class="collapse">
                            <div class="card-body">
                              <p id="isPasted"><strong>Съобщение за безопасност на продуктите</strong></p>
                              <p>
                                Вашата безопасност е наш основен приоритет. Нашите продукти отговарят на изискванията на Регламента за безопасност на продуктите на ЕС (ЕС) 2023/988 и покриват
                                най-високите стандарти за безопасност и качество, за да се гарантира безпроблемната работа на устройствата.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Нашите ангажименти към безопасността на продуктите</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Съответствие с директивите на ЕС:</strong> <br />Всички наши продукти се разработват и тестват в съответствие с действащите разпоредби за безопасност и здраве.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Оценка на риска и качество:</strong> <br />Всеки продукт преминава през обширни процедури за тестване, за да се гарантира максимална безопасност и
                                функционалност.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Информация за безопасност:</strong> <br />Нашите продукти се доставят с подробни инструкции и насоки за безопасност, които трябва да бъдат прочетени и спазвани
                                преди употреба.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Важни указания за безопасна употреба</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Използвайте оригинални резервни части:</strong> <br />Настоятелно препоръчваме да използвате само оригинални резервни части. Употребата на неизпитани части може
                                да компрометира безопасността и функционалността на устройството.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Не модифицирайте и не използвайте неправомерно устройството:</strong> <br />Моля, не модифицирайте ръчно устройството и го използвайте само по предназначение.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Изключете от електрическата мрежа:</strong> <br />При необходимост от поддръжка се уверете, че устройството е напълно изключено от електрическата мрежа, за да
                                избегнете електрически опасности.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Спазвайте ръководството за употреба:</strong> <br />Винаги следвайте инструкциите, посочени в ръководството или наръчника на производителя. Отклоненията от тях
                                могат да доведат до неизправности или рискове за безопасността.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Свържете се с техническата поддръжка:</strong> <br />При съмнения или проблеми с устройството, нашият екип за техническа поддръжка е на разположение да ви
                                осигури компетентна помощ.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Вашата отговорност като потребител</strong></p>
                              <ul>
                                <li>Прочетете внимателно и разберете всички инструкции за безопасност и употреба.</li>
                                <li>Използвайте устройството само по предназначение и в предвидената среда.</li>
                                <li>Съхранявайте устройството на сигурно място, далеч от деца, освен ако не е изрично предназначено за тяхна употреба.</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p><strong>Контакт с нашата клиентска поддръжка</strong></p>
                              <p>За съдействие или въпроси сме винаги на ваше</p>
                            </div>
                          </div>
                        </div>
                        <div class="card">
                          <button
                            id="heading_67921b7679be1_7"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapse_67921b7679be1_7"
                            aria-expanded="false"
                            aria-controls="collapse_67921b7679be1_7"
                            class="card-header btn btn-link text-appearance collapsed "
                          >
                            <h5 class="h5 pr-5 mb-0">
                              Suomalainen
                              <i class="fa fa-chevron-down"></i>
                            </h5>
                          </button>
                          <div id="collapse_67921b7679be1_7" aria-labelledby="heading_67921b7679be1_7" data-parent="#accordion_67921b7679be1" class="collapse">
                            <div class="card-body">
                              <p id="isPasted"><strong>Tuoteturvallisuushuomautus</strong></p>
                              <p>
                                Turvallisuutesi on meille ensisijaisen tärkeää. Tuotteemme täyttävät EU:n tuoteturvallisuusasetuksen (EU) 2023/988 vaatimukset ja noudattavat korkeimpia turvallisuus-
                                ja laatuvaatimuksia laitteen sujuvan toiminnan takaamiseksi.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Sitoutumisemme tuoteturvallisuuteen</strong></p>
                              <p>
                                <br />
                              </p>
                              <p><strong>EU-direktiivien noudattaminen:</strong> <br />Kaikki tuotteemme suunnitellaan ja testataan voimassa olevien turvallisuus- ja terveyssäännösten mukaisesti.</p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Riskiarviointi ja laatu:</strong> <br />Jokainen tuote käy läpi kattavat testausprosessit, joilla varmistetaan maksimaalinen turvallisuus ja toiminnallisuus.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Turvallisuustiedot:</strong> <br />Tuotteemme toimitetaan yksityiskohtaisten käyttöohjeiden ja turvallisuusmääräysten kanssa, jotka on luettava ja noudatettava
                                ennen käyttöä.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Tärkeitä ohjeita turvalliseen käyttöön</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Käytä alkuperäisiä varaosia:</strong> <br />Suosittelemme käyttämään vain alkuperäisiä varaosia. Testaamattomien osien käyttö voi vaarantaa laitteen
                                turvallisuuden ja toimivuuden.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Älä muokkaa tai käytä laitetta väärin:</strong> <br />Älä muokkaa tai käsittele laitetta itse ja käytä sitä vain suunniteltuun tarkoitukseen.</p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Irrota laite sähköverkosta:</strong> <br />Jos huoltotöitä tarvitaan, varmista, että laite on täysin irrotettu sähköverkosta sähkövaarojen välttämiseksi.</p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Noudata käyttöohjetta:</strong> <br />Noudata aina valmistajan antamia käyttöohjeita. Poikkeamat voivat johtaa toimintahäiriöihin tai turvallisuusriskeihin.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Ota yhteyttä tekniseen asiakaspalveluun:</strong> <br />Jos olet epävarma tai kohtaat ongelmia laitteesi kanssa, tekninen asiakaspalvelumme on käytettävissäsi
                                tarjoamaan asiantuntevaa apua.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Käyttäjän vastuu</strong></p>
                              <ul>
                                <li>Lue ja ymmärrä kaikki turvallisuus- ja käyttöohjeet huolellisesti.</li>
                                <li>Käytä laitetta vain sen suunnitellulla tavalla ja ympäristössä.</li>
                                <li>Säilytä laite turvallisesti ja lasten ulottumattomissa, ellei sitä ole erityisesti tarkoitettu heidän käyttöönsä.</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p><strong>Ota yhteyttä asiakaspalveluumme</strong></p>
                              <p>Tarvitsetko tukea tai onko kysyttävää? Olemme aina käytettävissäsi:</p>
                              <ul>
                                <li><strong>Sähköposti:</strong> kundenservice@kms-handel.de</li>
                                <li><strong>Puhelin:</strong> +49 5921 81 999 - 0</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p>Luottamuksesi on meidän vastuumme. Yhdessä tuotteidemme ja turvallisen käytön avulla varmistamme, että voit nauttia korkealaatuisesta viihteestä huolettomasti.</p>
                            </div>
                          </div>
                        </div>
                        <div class="card">
                          <button
                            id="heading_67921b7679be1_8"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapse_67921b7679be1_8"
                            aria-expanded="false"
                            aria-controls="collapse_67921b7679be1_8"
                            class="card-header btn btn-link text-appearance collapsed "
                          >
                            <h5 class="h5 pr-5 mb-0">
                              Ελληνική
                              <i class="fa fa-chevron-down"></i>
                            </h5>
                          </button>
                          <div id="collapse_67921b7679be1_8" aria-labelledby="heading_67921b7679be1_8" data-parent="#accordion_67921b7679be1" class="collapse">
                            <div class="card-body">
                              <p id="isPasted"><strong>Ειδοποίηση Ασφάλειας Προϊόντος</strong></p>
                              <p>
                                Η ασφάλειά σας είναι η πρώτη μας προτεραιότητα. Τα προϊόντα μας συμμορφώνονται με τις απαιτήσεις του Κανονισμού Ασφάλειας Προϊόντων της ΕΕ (ΕΕ) 2023/988 και πληρούν τα
                                υψηλότερα πρότυπα ασφάλειας και ποιότητας για την εξασφάλιση της ομαλής λειτουργίας των συσκευών.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Οι δεσμεύσεις μας για την ασφάλεια των προϊόντων</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Συμμόρφωση με τις Οδηγίες της ΕΕ:</strong> <br />Όλα τα προϊόντα μας αναπτύσσονται και δοκιμάζονται σύμφωνα με τις ισχύουσες διατάξεις για την ασφάλεια και την
                                υγεία.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Αξιολόγηση κινδύνων και ποιότητα:</strong> <br />Κάθε προϊόν υποβάλλεται σε εκτενείς διαδικασίες δοκιμών για να διασφαλιστεί η μέγιστη ασφάλεια και
                                λειτουργικότητα.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Πληροφορίες για την ασφάλεια:</strong> <br />Τα προϊόντα μας παρέχονται με λεπτομερείς οδηγίες και κατευθυντήριες γραμμές ασφαλείας, οι οποίες πρέπει να
                                διαβάζονται και να τηρούνται πριν από τη χρήση.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Σημαντικές οδηγίες για ασφαλή χρήση</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Χρησιμοποιήστε γνήσια ανταλλακτικά:</strong> <br />Σας συνιστούμε ανεπιφύλακτα να χρησιμοποιείτε μόνο γνήσια ανταλλακτικά. Η χρήση μη ελεγμένων εξαρτημάτων
                                μπορεί να θέσει σε κίνδυνο την ασφάλεια και τη λειτουργικότητα της συσκευής.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Μην τροποποιείτε ή χρησιμοποιείτε το προϊόν για άλλους σκοπούς:</strong> <br />Παρακαλούμε να μην τροποποιείτε χειροκίνητα τη συσκευή και να τη χρησιμοποιείτε
                                μόνο σύμφωνα με τον προβλεπόμενο σκοπό της.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Αποσύνδεση από το ηλεκτρικό δίκτυο:</strong> <br />Εάν απαιτούνται εργασίες συντήρησης, βεβαιωθείτε ότι η συσκευή είναι πλήρως αποσυνδεδεμένη από το ηλεκτρικό
                                δίκτυο για την αποφυγή ηλεκτροπληξίας.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Ακολουθήστε το εγχειρίδιο χρήσης:</strong> <br />Πάντα να ακολουθείτε τις οδηγίες που παρέχονται στο εγχειρίδιο χρήσης ή στον οδηγό του κατασκευαστή. Οι
                                αποκλίσεις μπορεί να οδηγήσουν σε δυσλειτουργίες ή κινδύνους ασφαλείας.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Επικοινωνήστε με την τεχνική υποστήριξη:</strong> <br />Σε περίπτωση αμφιβολιών ή προβλημάτων με τη συσκευή σας, η τεχνική υποστήριξή μας είναι διαθέσιμη για να
                                σας προσφέρει επαγγελματική βοήθεια.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Η ευθύνη σας ως χρήστης</strong></p>
                              <ul>
                                <li>Διαβάστε και κατανοήστε προσεκτικά όλες τις οδηγίες ασφαλείας και χρήσης.</li>
                                <li>Χρησιμοποιήστε τη συσκευή αποκλειστικά με τον προβλεπόμενο τρόπο και στο κατάλληλο περιβάλλον.</li>
                                <li>Αποθηκεύστε τη συσκευή με ασφάλεια και μακριά από παιδιά, εκτός αν προορίζεται ρητά για τη χρήση τους.</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p><strong>Επικοινωνία με την υποστήριξη πελατών μας</strong></p>
                              <p>Για βοήθεια ή ερωτήσεις, είμαστε πάντα στη διάθεσή σας:</p>
                              <ul>
                                <li><strong>Email:</strong> kundenservice@kms-handel.de</li>
                                <li><strong>Τηλέφωνο:</strong> +49 5921 81 999 - 0</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p>
                                Η εμπιστοσύνη σας είναι η ευθύνη μας. Μαζί, με τα προϊόντα μας και τη δική σας ασφαλή χρήση, διασφαλίζουμε ότι μπορείτε να απολαμβάνετε υψηλής ποιότητας ψυχαγωγία χωρίς
                                ανησυχίες.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="card">
                          <button
                            id="heading_67921b7679be1_9"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapse_67921b7679be1_9"
                            aria-expanded="false"
                            aria-controls="collapse_67921b7679be1_9"
                            class="card-header btn btn-link text-appearance collapsed "
                          >
                            <h5 class="h5 pr-5 mb-0">
                              Norsk
                              <i class="fa fa-chevron-down"></i>
                            </h5>
                          </button>
                          <div id="collapse_67921b7679be1_9" aria-labelledby="heading_67921b7679be1_9" data-parent="#accordion_67921b7679be1" class="collapse">
                            <div class="card-body">
                              <p id="isPasted"><strong>Produkt sikkerhetsvarsel</strong></p>
                              <p>
                                Din sikkerhet er vår høyeste prioritet. Våre produkter er i samsvar med kravene i EU-forordningen om produktsikkerhet (EU) 2023/988 og oppfyller de høyeste sikkerhets-
                                og kvalitetsstandardene for å sikre problemfri drift av enhetene.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Våre forpliktelser til produktsikkerhet</strong></p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Overholdelse av EU-direktiver:</strong> <br />Alle våre produkter er utviklet og testet i samsvar med gjeldende sikkerhets- og helseforskrifter.</p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Risikvurdering og kvalitet:</strong> <br />Hvert produkt gjennomgår omfattende testprosedyrer for å sikre maksimal sikkerhet og funksjonalitet.</p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Sikkerhetsinformasjon:</strong> <br />Våre produkter leveres med detaljerte instruksjoner og sikkerhetsretningslinjer som må leses og følges før bruk.</p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Viktige instruksjoner for sikker bruk</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Bruk originale reservedeler:</strong> <br />Vi anbefaler på det sterkeste å bruke kun originale reservedeler. Bruk av utestede deler kan påvirke enhetens
                                sikkerhet og funksjonalitet.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Ikke manipuler eller misbruk enheten:</strong> <br />Vennligst manipuler ikke enheten manuelt og bruk den kun i henhold til dens opprinnelige formål.</p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Koble fra strømnettet:</strong> <br />Ved vedlikehold, vær sikker på at enheten er helt frakoblet strømnettet for å unngå elektriske farer.</p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Følg bruksanvisningen:</strong> <br />Følg alltid instruksjonene i brukerhåndboken eller produsentens veiledning. Avvik kan føre til funksjonsfeil eller
                                sikkerhetsrisikoer.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Kontakt teknisk kundeservice:</strong> <br />Ved tvil eller problemer med enheten, er vår tekniske kundeservice tilgjengelig for å gi kompetent hjelp.</p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Ditt ansvar som bruker</strong></p>
                              <ul>
                                <li>Les og forstå alle sikkerhets- og bruksanvisninger nøye.</li>
                                <li>Bruk enheten kun på den tiltenkte måten og i det angitte miljøet.</li>
                                <li>Oppbevar enheten på et sikkert sted, utenfor rekkevidde for barn, med mindre den er eksplisitt laget for deres bruk.</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p><strong>Kontakt vår kundeservice</strong></p>
                              <p>For støtte eller spørsmål er vi alltid tilgjengelig:</p>
                              <ul>
                                <li><strong>E-post:</strong> kundenservice@kms-handel.de</li>
                                <li><strong>Telefon:</strong> +49 5921 81 999 - 0</li>
                              </ul>
                              <p>Din tillit er vårt ansvar. Sammen, med våre produkter og din sikre bruk, sørger vi for at du kan nyte høykvalitets underholdning uten bekymringer.</p>
                            </div>
                          </div>
                        </div>
                        <div class="card">
                          <button
                            id="heading_67921b7679be1_10"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapse_67921b7679be1_10"
                            aria-expanded="false"
                            aria-controls="collapse_67921b7679be1_10"
                            class="card-header btn btn-link text-appearance collapsed "
                          >
                            <h5 class="h5 pr-5 mb-0">
                              Polski
                              <i class="fa fa-chevron-down"></i>
                            </h5>
                          </button>
                          <div id="collapse_67921b7679be1_10" aria-labelledby="heading_67921b7679be1_10" data-parent="#accordion_67921b7679be1" class="collapse">
                            <div class="card-body">
                              <p id="isPasted"><strong>Powiadomienie o bezpieczeństwie produktu</strong></p>
                              <p>
                                Twoje bezpieczeństwo jest dla nas najważniejsze. Nasze produkty spełniają wymagania rozporządzenia UE w sprawie bezpieczeństwa produktów (UE) 2023/988 i spełniają
                                najwyższe standardy bezpieczeństwa i jakości, zapewniając bezproblemową obsługę urządzeń.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Nasze zobowiązania w zakresie bezpieczeństwa produktu</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Zgodność z dyrektywami UE:</strong> <br />Wszystkie nasze produkty są opracowywane i testowane zgodnie z obowiązującymi przepisami dotyczącymi bezpieczeństwa i
                                zdrowia.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Ocena ryzyka i jakość:</strong> <br />Każdy produkt przechodzi szczegółowe procedury testowe w celu zapewnienia maksymalnego bezpieczeństwa i funkcjonalności.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Informacje dotyczące bezpieczeństwa:</strong> <br />Nasze produkty są dostarczane z szczegółowymi instrukcjami oraz wytycznymi bezpieczeństwa, które należy
                                przeczytać i przestrzegać przed użyciem.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Ważne wskazówki dotyczące bezpiecznego użytkowania</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Używaj tylko oryginalnych części zamiennych:</strong> <br />Zalecamy używanie wyłącznie oryginalnych części zamiennych. Używanie nieprzetestowanych części może
                                wpłynąć na bezpieczeństwo i sprawność urządzenia.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Nie modyfikuj ani nie używaj urządzenia w niewłaściwy sposób:</strong> <br />Prosimy nie modyfikować urządzenia ręcznie i używać go wyłącznie zgodnie z jego
                                przeznaczeniem.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Odłącz urządzenie od sieci elektrycznej:</strong> <br />Jeśli konieczne są prace konserwacyjne, upewnij się, że urządzenie jest całkowicie odłączone od sieci
                                elektrycznej, aby uniknąć zagrożeń elektrycznych.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Przestrzegaj instrukcji obsługi:</strong> <br />Zawsze postępuj zgodnie z instrukcjami zawartymi w podręczniku użytkownika lub instrukcji obsługi producenta.
                                Odbiegnięcie od nich może prowadzić do awarii lub zagrożeń dla bezpieczeństwa.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Skontaktuj się z obsługą techniczną:</strong> <br />W razie wątpliwości lub problemów z urządzeniem, nasza obsługa techniczna jest gotowa, aby udzielić Ci
                                fachowej pomocy.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Twoja odpowiedzialność jako użytkownika</strong></p>
                              <ul>
                                <li>Dokładnie przeczytaj i zrozum wszystkie instrukcje dotyczące bezpieczeństwa i użytkowania.</li>
                                <li>Używaj urządzenia wyłącznie w sposób zamierzony i w odpowiednich warunkach.</li>
                                <li>Przechowuj urządzenie w bezpiecznym miejscu, poza zasięgiem dzieci, chyba że jest ono przeznaczone do użytku przez dzieci.</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p><strong>Kontakt z naszą obsługą klienta</strong></p>
                              <p>W przypadku wsparcia lub pytań jesteśmy do Twojej dyspozycji:</p>
                              <ul>
                                <li><strong>E-mail:</strong> kundenservice@kms-handel.de</li>
                                <li><strong>Telefon:</strong> +49 5921 81 999 - 0</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p>
                                Twoje zaufanie to nasza odpowiedzialność. Razem, z naszymi produktami i Twoim bezpiecznym użytkowaniem, zadbamy o to, abyś mógł cieszyć się wysokiej jakości rozrywką
                                bez obaw.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="card">
                          <button
                            id="heading_67921b7679be1_11"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapse_67921b7679be1_11"
                            aria-expanded="false"
                            aria-controls="collapse_67921b7679be1_11"
                            class="card-header btn btn-link text-appearance collapsed "
                          >
                            <h5 class="h5 pr-5 mb-0">
                              Português
                              <i class="fa fa-chevron-down"></i>
                            </h5>
                          </button>
                          <div id="collapse_67921b7679be1_11" aria-labelledby="heading_67921b7679be1_11" data-parent="#accordion_67921b7679be1" class="collapse">
                            <div class="card-body">
                              <p id="isPasted"><strong>Aviso de Segurança do Produto</strong></p>
                              <p>
                                A sua segurança é a nossa principal prioridade. Os nossos produtos cumprem os requisitos do Regulamento de Segurança de Produtos da UE (UE) 2023/988 e atendem aos mais
                                elevados padrões de segurança e qualidade para garantir o funcionamento sem problemas dos dispositivos.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Os nossos compromissos com a segurança do produto</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Cumprimento das diretivas da UE:</strong> <br />Todos os nossos produtos são desenvolvidos e testados de acordo com as regulamentações de segurança e saúde em
                                vigor.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Avaliação de riscos e qualidade:</strong> <br />Cada produto passa por procedimentos de teste abrangentes para garantir a máxima segurança e funcionalidade.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Informações de segurança:</strong> <br />Os nossos produtos são fornecidos com instruções detalhadas e diretrizes de segurança, que devem ser lidas e seguidas
                                antes do uso.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Instruções importantes para o uso seguro</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Utilize peças de reposição originais:</strong> <br />Recomendamos vivamente que utilize apenas peças de reposição originais. O uso de peças não testadas pode
                                comprometer a segurança e a funcionalidade do dispositivo.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Não manipule ou utilize o dispositivo de forma indevida:</strong> <br />Por favor, não modifique o dispositivo manualmente e utilize-o apenas para o fim a que
                                se destina.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Desligue da rede elétrica:</strong> <br />Caso seja necessária manutenção, certifique-se de que o dispositivo está completamente desligado da rede elétrica para
                                evitar riscos elétricos.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Siga o manual de instruções:</strong> <br />Siga sempre as instruções do manual do utilizador ou as diretrizes do fabricante. Desvios podem causar mau
                                funcionamento ou riscos de segurança.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Contacte o serviço técnico de apoio ao cliente:</strong> <br />Em caso de dúvidas ou problemas com o seu dispositivo, o nosso serviço técnico está disponível
                                para lhe prestar apoio competente.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>A sua responsabilidade como utilizador</strong></p>
                              <ul>
                                <li>Leia e compreenda todas as instruções de segurança e operação com atenção.</li>
                                <li>Utilize o dispositivo apenas de acordo com a sua finalidade e no ambiente adequado.</li>
                                <li>Guarde o dispositivo em local seguro e fora do alcance das crianças, a menos que seja especificamente destinado para o seu uso.</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p><strong>Contacte o nosso serviço de apoio ao cliente</strong></p>
                              <p>Para apoio ou questões, estamos sempre à sua disposição:</p>
                              <ul>
                                <li><strong>E-mail:</strong> kundenservice@kms-handel.de</li>
                                <li><strong>Telefone:</strong> +49 5921 81 999 - 0</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p>
                                A sua confiança é a nossa responsabilidade. Juntos, com os nossos produtos e o seu uso seguro, garantimos que pode desfrutar de entretenimento de alta qualidade sem
                                preocupações.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="card">
                          <button
                            id="heading_67921b7679be1_12"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapse_67921b7679be1_12"
                            aria-expanded="false"
                            aria-controls="collapse_67921b7679be1_12"
                            class="card-header btn btn-link text-appearance collapsed "
                          >
                            <h5 class="h5 pr-5 mb-0">
                              Svensk
                              <i class="fa fa-chevron-down"></i>
                            </h5>
                          </button>
                          <div id="collapse_67921b7679be1_12" aria-labelledby="heading_67921b7679be1_12" data-parent="#accordion_67921b7679be1" class="collapse">
                            <div class="card-body">
                              <p id="isPasted"><strong>Produkt Säkerhetsinformation</strong></p>
                              <p>
                                Din säkerhet är vår högsta prioritet. Våra produkter uppfyller kraven i EU-förordningen om produktsäkerhet (EU) 2023/988 och uppfyller de högsta säkerhets- och
                                kvalitetsstandarderna för att säkerställa att enheten fungerar problemfritt.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Våra åtaganden för produktsäkerhet</strong></p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Följa EU-direktiv:</strong> <br />Alla våra produkter utvecklas och testas i enlighet med gällande säkerhets- och hälsoregler.</p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Riskbedömning och kvalitet:</strong> <br />Varje produkt genomgår omfattande testprocedurer för att säkerställa maximal säkerhet och funktionalitet.</p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Säkerhetsinformation:</strong> <br />Våra produkter levereras med detaljerade instruktioner och säkerhetsriktlinjer som måste läsas och följas innan användning.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Viktiga anvisningar för säker användning</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Använd endast originalreservdelar:</strong> <br />Vi rekommenderar starkt att du använder enbart originalreservdelar. Användning av obeprövade delar kan påverka
                                enhetens säkerhet och funktionalitet.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Manipulera eller använd inte enheten felaktigt:</strong> <br />Vänligen modifiera inte enheten manuellt och använd den endast för dess avsedda ändamål.</p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Koppla bort från elnätet:</strong> <br />Vid underhåll, se till att enheten är helt frånkopplad från elnätet för att undvika elektriska faror.</p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Följ bruksanvisningen:</strong> <br />Följ alltid instruktionerna i användarmanualen eller tillverkarens anvisningar. Avvikelser kan orsaka felaktig funktion
                                eller säkerhetsrisker.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Kontakta teknisk kundservice:</strong> <br />Vid tveksamheter eller problem med din enhet är vår tekniska kundservice tillgänglig för att ge kompetent hjälp.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Ditt ansvar som användare</strong></p>
                              <ul>
                                <li>Läs och förstå noggrant alla säkerhets- och användarinstruktioner.</li>
                                <li>Använd enheten endast på det sätt och i den miljö som den är avsedd för.</li>
                                <li>Förvara enheten på en säker plats och utom räckhåll för barn, om den inte är specifikt avsedd för deras användning.</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p><strong>Kontakta vår kundservice</strong></p>
                              <p>För support eller frågor står vi alltid till ditt förfogande:</p>
                              <ul>
                                <li><strong>E-post:</strong> kundenservice@kms-handel.de</li>
                                <li><strong>Telefon:</strong> +49 5921 81 999 - 0</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p>Din tillit är vårt ansvar. Tillsammans, med våra produkter och din säkra användning, säkerställer vi att du kan njuta av högkvalitativ underhållning utan bekymmer.</p>
                            </div>
                          </div>
                        </div>
                        <div class="card">
                          <button
                            id="heading_67921b7679be1_13"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapse_67921b7679be1_13"
                            aria-expanded="false"
                            aria-controls="collapse_67921b7679be1_13"
                            class="card-header btn btn-link text-appearance collapsed "
                          >
                            <h5 class="h5 pr-5 mb-0">
                              Slovensky
                              <i class="fa fa-chevron-down"></i>
                            </h5>
                          </button>
                          <div id="collapse_67921b7679be1_13" aria-labelledby="heading_67921b7679be1_13" data-parent="#accordion_67921b7679be1" class="collapse">
                            <div class="card-body">
                              <p id="isPasted"><strong>Upozornenie na bezpečnosť produktu</strong></p>
                              <p>
                                Vaša bezpečnosť je pre nás na prvom mieste. Naše produkty spĺňajú požiadavky Nariadenia EÚ o bezpečnosti výrobkov (EÚ) 2023/988 a spĺňajú najvyššie bezpečnostné a
                                kvalitné štandardy na zabezpečenie bezproblémovej prevádzky zariadení.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Naše záväzky v oblasti bezpečnosti produktu</strong></p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Dodržiavanie smerníc EÚ:</strong> <br />Všetky naše produkty sú vyvinuté a testované v súlade s platnými bezpečnostnými a zdravotnými predpismi.</p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Hodnotenie rizík a kvalita:</strong> <br />Každý produkt prechádza rozsiahlymi testovacími procedúrami na zabezpečenie maximálnej bezpečnosti a funkčnosti.</p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Informácie o bezpečnosti:</strong> <br />Naše produkty sú dodávané s podrobnými pokynmi a bezpečnostnými smernicami, ktoré je nutné prečítať a dodržiavať pred
                                použitím.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Dôležité pokyny pre bezpečné používanie</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Používajte len originálne náhradné diely:</strong> <br />Dôrazne odporúčame používať iba originálne náhradné diely. Použitie neschválených dielov môže ohroziť
                                bezpečnosť a funkčnosť zariadenia.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Nezmenšujte alebo nezneužívajte zariadenie:</strong> <br />Prosím, nezasahujte manuálne do zariadenia a používajte ho iba na účely, na ktoré je určené.</p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Odpojte zariadenie od elektrickej siete:</strong> <br />Ak sú potrebné údržbové práce, uistite sa, že zariadenie je úplne odpojené od elektrickej siete, aby sa
                                predišlo elektrickým nehodám.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Postupujte podľa návodu na použitie:</strong> <br />Vždy dodržiavajte pokyny uvedené v návode na použitie alebo pokyny výrobcu. Odchýlky môžu viesť k poruchám
                                alebo bezpečnostným rizikám.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Kontaktujte technickú zákaznícku podporu:</strong> <br />V prípade pochybností alebo problémov so zariadením je naša technická zákaznícka podpora k dispozícii,
                                aby vám poskytla odbornú pomoc.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Vaša zodpovednosť ako používateľa</strong></p>
                              <ul>
                                <li>Dôkladne si prečítajte a pochopte všetky pokyny týkajúce sa bezpečnosti a používania.</li>
                                <li>Používajte zariadenie iba spôsobom, na ktorý je určené, a v príslušnom prostredí.</li>
                                <li>Uchovávajte zariadenie na bezpečnom mieste a mimo dosahu detí, ak nie je výslovne určené na ich používanie.</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p><strong>Kontaktujte našu zákaznícku podporu</strong></p>
                              <p>Pre podporu alebo otázky sme vám k dispozícii:</p>
                              <ul>
                                <li><strong>E-mail:</strong> kundenservice@kms-handel.de</li>
                                <li><strong>Telefón:</strong> +49 5921 81 999 - 0</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p>Vaša dôvera je našou zodpovednosťou. Spoločne, s našimi produktmi a vašim bezpečným používaním, zabezpečíme, že si môžete vychutnať kvalitnú zábavu bez obáv.</p>
                            </div>
                          </div>
                        </div>
                        <div class="card">
                          <button
                            id="heading_67921b7679be1_14"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapse_67921b7679be1_14"
                            aria-expanded="false"
                            aria-controls="collapse_67921b7679be1_14"
                            class="card-header btn btn-link text-appearance collapsed "
                          >
                            <h5 class="h5 pr-5 mb-0">
                              Slovenski
                              <i class="fa fa-chevron-down"></i>
                            </h5>
                          </button>
                          <div id="collapse_67921b7679be1_14" aria-labelledby="heading_67921b7679be1_14" data-parent="#accordion_67921b7679be1" class="collapse">
                            <div class="card-body">
                              <p id="isPasted"><strong>Obvestilo o varnosti izdelka</strong></p>
                              <p>
                                Vaša varnost je za nas na prvem mestu. Naši izdelki izpolnjujejo zahteve Uredbe EU o varnosti izdelkov (EU) 2023/988 in izpolnjujejo najvišje varnostne in kakovostne
                                standarde za zagotovitev nemotenega delovanja naprav.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Naše zaveze glede varnosti izdelkov</strong></p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Upoštevanje evropskih direktiv:</strong> <br />Vsi naši izdelki so razviti in testirani v skladu z veljavnimi predpisi o varnosti in zdravju.</p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Ocena tveganja in kakovost:</strong> <br />Vsak izdelek prestane obsežne testne postopke, da se zagotovi največja varnost in funkcionalnost.</p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Informacije o varnosti:</strong> <br />Naši izdelki so opremljeni z podrobnimi navodili in varnostnimi smernicami, ki jih morate prebrati in upoštevati pred
                                uporabo.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Pomembna navodila za varno uporabo</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Uporabljajte samo originalne nadomestne dele:</strong> <br />Opravičujemo vas, da uporabite samo originalne nadomestne dele. Uporaba nepreverjenih delov lahko
                                vpliva na varnost in funkcionalnost naprave.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Ne spreminjajte ali zlorabljajte naprave:</strong> <br />Prosimo, ne spreminjajte naprave ročno in jo uporabljajte le za predvidene namene.</p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Odklopite iz električnega omrežja:</strong> <br />Če je potrebna vzdrževanje, se prepričajte, da je naprava popolnoma odklopljena od električnega omrežja, da se
                                izognete električnim nevarnostim.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Sledite navodilom za uporabo:</strong> <br />Vedno sledite navodilom v priročniku za uporabnika ali navodilom proizvajalca. Odstopanja lahko povzročijo okvare
                                ali tveganja za varnost.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Kontaktirajte tehnično podporo strankam:</strong> <br />V primeru dvomov ali težav z napravo je naša tehnična podpora na voljo za strokovno pomoč.</p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Vaša odgovornost kot uporabnik</strong></p>
                              <ul>
                                <li>Previdno preberite in razumite vsa varnostna in uporabniška navodila.</li>
                                <li>Uporabljajte napravo samo na predviden način in v primernem okolju.</li>
                                <li>Napravo shranjujte na varnem mestu in izven dosega otrok, razen če ni posebej namenjena za njihovo uporabo.</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p><strong>Kontaktirajte našo podporo strankam</strong></p>
                              <p>Za pomoč ali vprašanja smo vam vedno na voljo:</p>
                              <ul>
                                <li><strong>E-pošta:</strong> kundenservice@kms-handel.de</li>
                                <li><strong>Telefon:</strong> +49 5921 81 999 - 0</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p>Vaša zaupanje je naša odgovornost. Skupaj, z našimi izdelki in vašo varno uporabo, zagotavljamo, da boste lahko uživali v visokokakovostni zabavi brez skrbi.</p>
                            </div>
                          </div>
                        </div>
                        <div class="card">
                          <button
                            id="heading_67921b7679be1_15"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapse_67921b7679be1_15"
                            aria-expanded="false"
                            aria-controls="collapse_67921b7679be1_15"
                            class="card-header btn btn-link text-appearance collapsed "
                          >
                            <h5 class="h5 pr-5 mb-0">
                              Español
                              <i class="fa fa-chevron-down"></i>
                            </h5>
                          </button>
                          <div id="collapse_67921b7679be1_15" aria-labelledby="heading_67921b7679be1_15" data-parent="#accordion_67921b7679be1" class="collapse">
                            <div class="card-body">
                              <p id="isPasted"><strong>Aviso de seguridad del producto</strong></p>
                              <p>
                                Su seguridad es nuestra principal prioridad. Nuestros productos cumplen con los requisitos del Reglamento de Seguridad de Productos de la UE (UE) 2023/988 y cumplen con
                                los más altos estándares de seguridad y calidad para garantizar un funcionamiento sin problemas de los dispositivos.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Nuestros compromisos con la seguridad del producto</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Cumplimiento de las directivas de la UE:</strong> <br />Todos nuestros productos se desarrollan y prueban de acuerdo con las normativas de seguridad y salud
                                vigentes.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Evaluación de riesgos y calidad:</strong> <br />Cada producto pasa por procedimientos de prueba exhaustivos para garantizar la máxima seguridad y funcionalidad.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Información de seguridad:</strong> <br />Nuestros productos se entregan con instrucciones detalladas y directrices de seguridad que deben leerse y seguirse
                                antes de su uso.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Instrucciones importantes para un uso seguro</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Utilice solo repuestos originales:</strong> <br />Le recomendamos encarecidamente que utilice solo repuestos originales. El uso de piezas no probadas puede
                                afectar la seguridad y el funcionamiento del dispositivo.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>No manipule ni abuse del dispositivo:</strong> <br />Por favor, no modifique manualmente el dispositivo y utilícelo solo para el propósito para el cual fue
                                diseñado.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Desconéctelo de la red eléctrica:</strong> <br />Si se requiere mantenimiento, asegúrese de que el dispositivo esté completamente desconectado de la red
                                eléctrica para evitar peligros eléctricos.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Siga el manual de instrucciones:</strong> <br />Siempre siga las instrucciones del manual del usuario o las directrices del fabricante. Las desviaciones pueden
                                provocar fallos o riesgos de seguridad.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Póngase en contacto con el servicio técnico de atención al cliente:</strong> <br />En caso de dudas o problemas con su dispositivo, nuestro servicio técnico
                                está disponible para brindarle apoyo profesional.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Su responsabilidad como usuario</strong></p>
                              <ul>
                                <li>Lea y comprenda detenidamente todas las instrucciones de seguridad y uso.</li>
                                <li>Use el dispositivo solo de la manera prevista y en el entorno adecuado.</li>
                                <li>Guarde el dispositivo en un lugar seguro y fuera del alcance de los niños, a menos que esté específicamente diseñado para su uso.</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p><strong>Póngase en contacto con nuestro servicio de atención al cliente</strong></p>
                              <p>Para obtener soporte o realizar preguntas, estamos a su disposición:</p>
                              <ul>
                                <li><strong>Correo electrónico:</strong> kundenservice@kms-handel.de</li>
                                <li><strong>Teléfono:</strong> +49 5921 81 999 - 0</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p>
                                Su confianza es nuestra responsabilidad. Juntos, con nuestros productos y su uso seguro, nos aseguramos de que pueda disfrutar de un entretenimiento de alta calidad sin
                                preocupaciones.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="card">
                          <button
                            id="heading_67921b7679be1_16"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapse_67921b7679be1_16"
                            aria-expanded="false"
                            aria-controls="collapse_67921b7679be1_16"
                            class="card-header btn btn-link text-appearance collapsed "
                          >
                            <h5 class="h5 pr-5 mb-0">
                              Magyar
                              <i class="fa fa-chevron-down"></i>
                            </h5>
                          </button>
                          <div id="collapse_67921b7679be1_16" aria-labelledby="heading_67921b7679be1_16" data-parent="#accordion_67921b7679be1" class="collapse">
                            <div class="card-body">
                              <p id="isPasted"><strong>Termékbiztonsági értesítés</strong></p>
                              <p>
                                Az Ön biztonsága számunkra az elsődleges prioritás. Termékeink megfelelnek az EU termékbiztonsági rendelet (EU) 2023/988 követelményeinek, és a legmagasabb biztonsági
                                és minőségi előírásoknak, hogy biztosítsák a készülékek problémamentes működését.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Elkötelezettségünk a termékbiztonság iránt</strong></p>
                              <p>
                                <br />
                              </p>
                              <p><strong>EU irányelvek betartása:</strong> <br />Minden termékünket a hatályos biztonsági és egészségügyi előírásoknak megfelelően fejlesztjük és teszteljük.</p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Kockázatértékelés és minőség:</strong> <br />Minden egyes termék átfogó tesztelési eljárásokon esik át a maximális biztonság és funkcionalitás biztosítása
                                érdekében.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Biztonsági információk:</strong> <br />Termékeink részletes használati utasításokkal és biztonsági előírásokkal kerülnek forgalomba, amelyeket a használat előtt
                                el kell olvasni és be kell tartani.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Fontos útmutatások a biztonságos használathoz</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Használjon csak eredeti pótalkatrészeket:</strong> <br />Határozottan javasoljuk, hogy kizárólag eredeti pótalkatrészeket használjon. A nem tesztelt alkatrészek
                                használata veszélyeztetheti a készülék biztonságát és működését.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Ne módosítsa vagy használja nem megfelelően a készüléket:</strong> <br />Kérjük, ne módosítsa kézzel a készüléket, és csak annak rendeltetésszerű használatra
                                alkalmazza.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Húzza ki a készüléket az elektromos hálózatból:</strong> <br />Ha karbantartásra van szükség, győződjön meg arról, hogy a készülék teljesen le van választva az
                                elektromos hálózatról, hogy elkerülje az elektromos veszélyeket.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Kövesse a használati utasítást:</strong> <br />Mindig kövesse a felhasználói kézikönyvben vagy a gyártó utasításaiban szereplő előírásokat. Az eltérések
                                meghibásodásokhoz vagy biztonsági kockázatokhoz vezethetnek.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Lépjen kapcsolatba a műszaki ügyfélszolgálattal:</strong> <br />Kérdésekkel vagy problémákkal kapcsolatban műszaki ügyfélszolgálatunk rendelkezésére áll, hogy
                                szakmai segítséget nyújtson.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Az Ön felelőssége, mint felhasználó</strong></p>
                              <ul>
                                <li>Gondosan olvassa el és értse meg az összes biztonsági és használati utasítást.</li>
                                <li>Használja a készüléket csak annak rendeltetésszerű módon és megfelelő környezetben.</li>
                                <li>Tárolja a készüléket biztonságos helyen, és tartsa távol a gyermekektől, hacsak azt kifejezetten nem gyermekek számára tervezték.</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p><strong>Lépjen kapcsolatba ügyfélszolgálatunkkal</strong></p>
                              <p>Támogatásért vagy kérdésekért bármikor elérhet bennünket:</p>
                              <ul>
                                <li><strong>E-mail:</strong> kundenservice@kms-handel.de</li>
                                <li><strong>Telefon:</strong> +49 5921 81 999 - 0</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p>
                                Az Ön bizalma a mi felelősségünk. Közösen, termékeinkkel és az Ön biztonságos használatával biztosítjuk, hogy prémium szórakozásban élvezhesse a gondtalan pillanatokat.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="card">
                          <button
                            id="heading_67921b7679be1_17"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapse_67921b7679be1_17"
                            aria-expanded="false"
                            aria-controls="collapse_67921b7679be1_17"
                            class="card-header btn btn-link text-appearance collapsed "
                          >
                            <h5 class="h5 pr-5 mb-0">
                              Română
                              <i class="fa fa-chevron-down"></i>
                            </h5>
                          </button>
                          <div id="collapse_67921b7679be1_17" aria-labelledby="heading_67921b7679be1_17" data-parent="#accordion_67921b7679be1" class="collapse">
                            <div class="card-body">
                              <p id="isPasted"><strong>Avertisment de siguranță a produsului</strong></p>
                              <p>
                                Siguranța dumneavoastră este prioritatea noastră principală. Produsele noastre respectă cerințele Regulamentului UE privind siguranța produselor (UE) 2023/988 și
                                îndeplinesc cele mai înalte standarde de siguranță și calitate pentru a asigura o funcționare perfectă a dispozitivelor.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Angajamentele noastre pentru siguranța produsului</strong></p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Respectarea directivelor UE:</strong> <br />Toate produsele noastre sunt dezvoltate și testate conform reglementărilor de siguranță și sănătate în vigoare.</p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Evaluarea riscurilor și calitatea:</strong> <br />Fiecare produs trece prin proceduri de testare extinse pentru a asigura siguranța și funcționalitatea maximă.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Informații de siguranță:</strong> <br />Produsele noastre sunt livrate cu instrucțiuni detaliate și ghiduri de siguranță care trebuie citite și urmate înainte
                                de utilizare.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Instrucțiuni importante pentru utilizarea sigură</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Folosiți doar piese de schimb originale:</strong> <br />Recomandăm cu tărie să utilizați doar piese de schimb originale. Utilizarea pieselor necertificate poate
                                afecta siguranța și funcționalitatea dispozitivului.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Nu modificați sau utilizați dispozitivul în mod impropriu:</strong> <br />Vă rugăm să nu modificați manual dispozitivul și să-l utilizați doar pentru scopul
                                pentru care a fost destinat.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Deconectați-l de la rețeaua electrică:</strong> <br />Dacă este necesară întreținerea, asigurați-vă că dispozitivul este complet deconectat de la rețeaua
                                electrică pentru a preveni pericolele electrice.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Urmați manualul de utilizare:</strong> <br />Urmați întotdeauna instrucțiunile din manualul utilizatorului sau ghidurile producătorului. Abaterile pot duce la
                                defecțiuni sau riscuri de siguranță.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Contactați serviciul tehnic de asistență clienți:</strong> <br />În cazul în care aveți îndoieli sau întâmpinați probleme cu dispozitivul dumneavoastră,
                                serviciul nostru tehnic de asistență clienți este disponibil pentru a vă oferi suport profesionist.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Responsabilitatea dumneavoastră ca utilizator</strong></p>
                              <ul>
                                <li>Citiți și înțelegeți cu atenție toate instrucțiunile de siguranță și utilizare.</li>
                                <li>Utilizați dispozitivul numai în scopul pentru care a fost destinat și în mediul adecvat.</li>
                                <li>Depozitați dispozitivul într-un loc sigur și ferit de copii, cu excepția cazului în care este destinat utilizării acestora.</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p><strong>Contactați serviciul nostru de asistență clienți</strong></p>
                              <p>Pentru suport sau întrebări, suntem întotdeauna la dispoziția dumneavoastră:</p>
                              <ul>
                                <li><strong>Email:</strong> kundenservice@kms-handel.de</li>
                                <li><strong>Telefon:</strong> +49 5921 81 999 - 0</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p>
                                Încrederea dumneavoastră este responsabilitatea noastră. Împreună, cu produsele noastre și utilizarea sigură a acestora, asigurăm că veți putea să vă bucurați de
                                divertisment de înaltă calitate, fără griji.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="card">
                          <button
                            id="heading_67921b7679be1_18"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapse_67921b7679be1_18"
                            aria-expanded="false"
                            aria-controls="collapse_67921b7679be1_18"
                            class="card-header btn btn-link text-appearance collapsed "
                          >
                            <h5 class="h5 pr-5 mb-0">
                              Dansk
                              <i class="fa fa-chevron-down"></i>
                            </h5>
                          </button>
                          <div id="collapse_67921b7679be1_18" aria-labelledby="heading_67921b7679be1_18" data-parent="#accordion_67921b7679be1" class="collapse">
                            <div class="card-body">
                              <p id="isPasted"><strong>Produkt sikkerhedsoplysninger</strong></p>
                              <p>
                                Din sikkerhed er vores højeste prioritet. Vore produkter opfylder kravene i EU-forordningen om produktsikkerhed (EU) 2023/988 og opfylder de højeste sikkerheds- og
                                kvalitetsstandarder for at sikre en problemfri enhedens drift.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Vore forpligtelser til produktsikkerhed</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Overholdelse af EU-direktiver:</strong> <br />Alle vores produkter er udviklet og testet i overensstemmelse med gældende sikkerheds- og sundhedsbestemmelser.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Risikovurdering og kvalitet:</strong> <br />Hvert produkt gennemgår omfattende testprocedurer for at sikre maksimal sikkerhed og funktionalitet.</p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Sikkerhedsinformation:</strong> <br />Vore produkter leveres med detaljerede instruktioner og sikkerhedsforskrifter, som skal læses og følges, inden de tages i
                                brug.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Vigtige anvisninger for sikker brug</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Brug kun originale reservedele:</strong> <br />Vi anbefaler kraftigt at bruge kun originale reservedele. Brug af uafprøvede dele kan påvirke enhedens sikkerhed
                                og funktionalitet.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Manipulér ikke eller misbrug ikke enheden:</strong> <br />Venligst ændr ikke enheden manuelt og brug den kun til det tilsigtede formål.</p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Frakobl enheden fra strømnettet:</strong> <br />Hvis vedligeholdelse er nødvendig, skal du sørge for, at enheden er helt frakoblet fra strømnettet for at undgå
                                elektriske farer.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Følg brugsanvisningen:</strong> <br />Følg altid instruktionerne i brugervejledningen eller producentens anvisninger. Afvigelser kan føre til funktionsfejl
                                eller sikkerhedsrisici.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Kontakt teknisk kundeservice:</strong> <br />I tilfælde af tvivl eller problemer med din enhed er vores tekniske kundeservice til rådighed for at yde kompetent
                                assistance.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Dit ansvar som bruger</strong></p>
                              <ul>
                                <li>Læs og forstå alle sikkerheds- og brugsanvisninger omhyggeligt.</li>
                                <li>Brug enheden kun på den måde og i det miljø, den er beregnet til.</li>
                                <li>Opbevar enheden et sikkert sted og uden for børns rækkevidde, medmindre det udtrykkeligt er beregnet til deres brug.</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p><strong>Kontakt vores kundeservice</strong></p>
                              <p>For support eller spørgsmål er vi altid til din rådighed:</p>
                              <ul>
                                <li><strong>E-mail:</strong> kundenservice@kms-handel.de</li>
                                <li><strong>Telefon:</strong> +49 5921 81 999 - 0</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p>Din tillid er vores ansvar. Sammen, med vores produkter og din sikre brug af dem, sikrer vi, at du kan nyde kvalitetsunderholdning uden bekymringer.</p>
                            </div>
                          </div>
                        </div>
                        <div class="card">
                          <button
                            id="heading_67921b7679be1_19"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapse_67921b7679be1_19"
                            aria-expanded="false"
                            aria-controls="collapse_67921b7679be1_19"
                            class="card-header btn btn-link text-appearance collapsed "
                          >
                            <h5 class="h5 pr-5 mb-0">
                              Eesti
                              <i class="fa fa-chevron-down"></i>
                            </h5>
                          </button>
                          <div id="collapse_67921b7679be1_19" aria-labelledby="heading_67921b7679be1_19" data-parent="#accordion_67921b7679be1" class="collapse">
                            <div class="card-body">
                              <p id="isPasted"><strong>Toote turvateatis</strong></p>
                              <p>
                                Teie turvalisus on meie peamine prioriteet. Meie tooted vastavad ELi tooteohutuse määruse (EL) 2023/988 nõuetele ja täidavad kõrgeima ohutuse ja kvaliteedi standardeid,
                                tagades seadmete sujuva töö.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Meie pühendumus tooteohutusele</strong></p>
                              <p>
                                <br />
                              </p>
                              <p><strong>ELi direktiivide järgimine:</strong> <br />Kõik meie tooted on välja töötatud ja testitud vastavalt kehtivatele ohutuse ja tervise määrustele.</p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Riskihindamine ja kvaliteet:</strong> <br />Iga toode läbib ulatuslikud testimisprotseduurid maksimaalse ohutuse ja funktsionaalsuse tagamiseks.</p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Ohutusteave:</strong> <br />Meie tooted on varustatud üksikasjalike juhiste ja ohutusnõuetega, mis tuleb enne kasutamist lugeda ja järgida.</p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Olulised juhised ohutuks kasutamiseks</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Kasutage ainult originaalosasid:</strong> <br />Soovitame tungivalt kasutada ainult originaalosasid. Mittetöödeldud osade kasutamine võib mõjutada seadme
                                ohutust ja funktsionaalsust.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Ärge muutke ega väärkasutage seadet:</strong> <br />Palun ärge muutke seadet käsitsi ja kasutage seda ainult ettenähtud eesmärkidel.</p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Lülitage seade välja toiteallikast:</strong> <br />Kui hooldustööd on vajalikud, veenduge, et seade oleks täielikult toiteallikast lahti ühendatud, et vältida
                                elektrilisi ohte.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Järgige kasutusjuhendit:</strong> <br />Järgige alati kasutusjuhendis või tootja juhistes toodud juhiseid. Eiramine võib põhjustada rikkeid või ohutusriske.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Võtke ühendust tehnilise klienditeenindusega:</strong> <br />Kahtluste või probleemide korral oma seadmega on meie tehniline klienditeenindus valmis pakkuma
                                professionaalset abi.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Teie vastutus kasutajana</strong></p>
                              <ul>
                                <li>Loe ja mõista hoolikalt kõiki ohutus- ja kasutusjuhiseid.</li>
                                <li>Kasutage seadet ainult ettenähtud viisil ja sobivas keskkonnas.</li>
                                <li>Hoidke seadet turvalises kohas ja lastele kergesti kättesaamatus kohas, välja arvatud juhul, kui see on mõeldud nende kasutamiseks.</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p><strong>Võtke ühendust meie klienditeenindusega</strong></p>
                              <p>Toetuse või küsimuste korral oleme alati teie käsutuses:</p>
                              <ul>
                                <li><strong>E-post:</strong> kundenservice@kms-handel.de</li>
                                <li><strong>Telefon:</strong> +49 5921 81 999 - 0</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p>Teie usaldus on meie vastutus. Koos meie toodete ja teie ohutu kasutamisega tagame, et saate nautida kvaliteetset meelelahutust muretult.</p>
                            </div>
                          </div>
                        </div>
                        <div class="card">
                          <button
                            id="heading_67921b7679be1_20"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapse_67921b7679be1_20"
                            aria-expanded="false"
                            aria-controls="collapse_67921b7679be1_20"
                            class="card-header btn btn-link text-appearance collapsed "
                          >
                            <h5 class="h5 pr-5 mb-0">
                              Česky
                              <i class="fa fa-chevron-down"></i>
                            </h5>
                          </button>
                          <div id="collapse_67921b7679be1_20" aria-labelledby="heading_67921b7679be1_20" data-parent="#accordion_67921b7679be1" class="collapse">
                            <div class="card-body">
                              <p id="isPasted"><strong>Bezpečnostní upozornění na výrobek</strong></p>
                              <p>
                                Vaše bezpečnost je pro nás na prvním místě. Naše produkty splňují požadavky nařízení EU o bezpečnosti výrobků (EU) 2023/988 a splňují nejvyšší bezpečnostní a
                                kvalitativní standardy pro zajištění bezproblémového provozu zařízení.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Naše závazky k bezpečnosti výrobků</strong></p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Dodržování směrnic EU:</strong> <br />Všechny naše produkty jsou vyvíjeny a testovány v souladu s platnými předpisy o bezpečnosti a ochraně zdraví.</p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Hodnocení rizik a kvalita:</strong> <br />Každý produkt prochází rozsáhlými testovacími postupy, které zajišťují maximální bezpečnost a funkčnost.</p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Informace o bezpečnosti:</strong> <br />Naše produkty jsou dodávány s podrobnými pokyny a bezpečnostními předpisy, které je nutné před použitím přečíst a
                                dodržovat.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Důležitá upozornění pro bezpečné použití</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Používejte pouze originální náhradní díly:</strong> <br />Důrazně doporučujeme používat pouze originální náhradní díly. Použití neověřených dílů může ovlivnit
                                bezpečnost a funkčnost zařízení.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Nepřetvářejte ani nezneužívejte zařízení:</strong> <br />Prosím, neměňte zařízení ručně a používejte je pouze k zamýšlenému účelu.</p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Odpojte zařízení od elektrické sítě:</strong> <br />Pokud je nutná údržba, ujistěte se, že je zařízení úplně odpojeno od elektrické sítě, aby se vyloučily
                                elektrické nebezpečí.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Dodržujte návod k použití:</strong> <br />Vždy postupujte podle pokynů v uživatelském manuálu nebo pokynů výrobce. Odchylky mohou vést k poruchám nebo
                                bezpečnostním rizikům.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Kontaktujte technickou zákaznickou podporu:</strong> <br />V případě pochybností nebo problémů s vaším zařízením je naše technická zákaznická podpora k
                                dispozici pro odbornou pomoc.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Vaše odpovědnost jako uživatele</strong></p>
                              <ul>
                                <li>Pečlivě si přečtěte a pochopte všechna bezpečnostní a provozní upozornění.</li>
                                <li>Používejte zařízení pouze způsobem a v prostředí, pro které bylo určeno.</li>
                                <li>Ukládejte zařízení na bezpečném místě, mimo dosah dětí, pokud není výslovně určeno pro jejich použití.</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p><strong>Kontaktujte náš zákaznický servis</strong></p>
                              <p>Pro podporu nebo dotazy jsme vám kdykoli k dispozici:</p>
                              <ul>
                                <li><strong>E-mail:</strong> kundenservice@kms-handel.de</li>
                                <li><strong>Telefon:</strong> +49 5921 81 999 - 0</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p>Vaše důvěra je naší odpovědností. Společně, s našimi produkty a vaším bezpečným používáním, zajistíme, že si budete moci vychutnávat kvalitní zábavu bez starostí.</p>
                            </div>
                          </div>
                        </div>
                        <div class="card">
                          <button
                            id="heading_67921b7679be1_21"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapse_67921b7679be1_21"
                            aria-expanded="false"
                            aria-controls="collapse_67921b7679be1_21"
                            class="card-header btn btn-link text-appearance collapsed "
                          >
                            <h5 class="h5 pr-5 mb-0">
                              Lietuvių kalba
                              <i class="fa fa-chevron-down"></i>
                            </h5>
                          </button>
                          <div id="collapse_67921b7679be1_21" aria-labelledby="heading_67921b7679be1_21" data-parent="#accordion_67921b7679be1" class="collapse">
                            <div class="card-body">
                              <p id="isPasted"><strong>Produkto saugos pranešimas</strong></p>
                              <p>
                                Jūsų saugumas mums yra svarbiausias. Mūsų produktai atitinka ES produktų saugos reglamento (ES) 2023/988 reikalavimus ir atitinka aukščiausius saugos ir kokybės
                                standartus, užtikrinančius sklandų įrenginių veikimą.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Mūsų įsipareigojimai produkto saugai</strong></p>
                              <p>
                                <br />
                              </p>
                              <p><strong>ES direktyvų laikymasis:</strong> <br />Visi mūsų produktai yra kuriami ir testuojami pagal galiojančius saugos ir sveikatos reglamentus.</p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Rizikos vertinimas ir kokybė:</strong> <br />Kiekvienas produktas pereina išsamias bandymo procedūras, kad būtų užtikrintas maksimalus saugumas ir
                                funkcionalumas.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Saugos informacija:</strong> <br />Mūsų produktai pateikiami su išsamiais naudojimo ir saugos nurodymais, kuriuos būtina perskaityti ir laikytis prieš
                                naudojant.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Svarbios instrukcijos saugiam naudojimui</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Naudokite tik originalias atsargines dalis:</strong> <br />Stipriai rekomenduojame naudoti tik originalias atsargines dalis. Nepritvirtintos dalys gali paveikti
                                įrenginio saugumą ir funkcionalumą.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Nekeiskite ir nesinaudokite įrenginiu netinkamai:</strong> <br />Prašome nesikeisti įrenginio rankiniu būdu ir naudoti jį tik numatytam tikslui.</p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Atjunkite nuo elektros tinklo:</strong> <br />Jei reikia atlikti priežiūrą, įsitikinkite, kad įrenginys visiškai atjungtas nuo elektros tinklo, kad išvengtumėte
                                elektros pavojų.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Laikykitės naudojimo instrukcijos:</strong> <br />Visada laikykitės naudotojo vadove arba gamintojo nurodytų nurodymų. Nukrypimai gali sukelti funkcijų
                                sutrikimus ar saugos pavojus.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Susisiekite su technine klientų aptarnavimo tarnyba:</strong> <br />Jei turite abejonių arba kyla problemų su įrenginiu, mūsų techninė klientų aptarnavimo
                                tarnyba pasiruošusi suteikti profesionalią pagalbą.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Jūsų atsakomybė kaip vartotojo</strong></p>
                              <ul>
                                <li>Kruopščiai perskaitykite ir supraskite visas saugos ir naudojimo instrukcijas.</li>
                                <li>Naudokite įrenginį tik numatyta tvarka ir tinkamoje aplinkoje.</li>
                                <li>Laikykite įrenginį saugioje vietoje ir toli nuo vaikų, jei jis nėra skirtas jų naudojimui.</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p><strong>Susisiekite su mūsų klientų aptarnavimo tarnyba</strong></p>
                              <p>Pagalbos arba klausimų atveju mes visada esame jums pasiekiami:</p>
                              <ul>
                                <li><strong>El. paštas:</strong> kundenservice@kms-handel.de</li>
                                <li><strong>Telefonas:</strong> +49 5921 81 999 - 0</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p>
                                Jūsų pasitikėjimas yra mūsų atsakomybė. Kartu su mūsų produktais ir jūsų saugiu naudojimu mes užtikriname, kad galėtumėte mėgautis aukštos kokybės pramogomis be
                                rūpesčių.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="card">
                          <button
                            id="heading_67921b7679be1_22"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapse_67921b7679be1_22"
                            aria-expanded="false"
                            aria-controls="collapse_67921b7679be1_22"
                            class="card-header btn btn-link text-appearance collapsed "
                          >
                            <h5 class="h5 pr-5 mb-0">
                              Croatian
                              <i class="fa fa-chevron-down"></i>
                            </h5>
                          </button>
                          <div id="collapse_67921b7679be1_22" aria-labelledby="heading_67921b7679be1_22" data-parent="#accordion_67921b7679be1" class="collapse">
                            <div class="card-body">
                              <p id="isPasted"><strong>Sigurnosna obavijest o proizvodu</strong></p>
                              <p>
                                Vaša sigurnost nam je na prvom mjestu. Naši proizvodi udovoljavaju zahtjevima Uredbe EU o sigurnosti proizvoda (EU) 2023/988 i ispunjavaju najviše sigurnosne i
                                kvalitetne standarde za osiguranje nesmetanog rada uređaja.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Naše obveze za sigurnost proizvoda</strong></p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Usklađenost s EU smjernicama:</strong> <br />Svi naši proizvodi razvijaju se i testiraju u skladu s važećim propisima o sigurnosti i zdravlju.</p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Procjena rizika i kvaliteta:</strong> <br />Svaki proizvod prolazi kroz opsežne postupke ispitivanja kako bi se osigurala maksimalna sigurnost i funkcionalnost.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Sigurnosne informacije:</strong> <br />Naši proizvodi dolaze s detaljnim uputama i sigurnosnim smjernicama koje je nužno pročitati i slijediti prije uporabe.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Važne upute za sigurno korištenje</strong></p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Koristite samo originalne rezervne dijelove:</strong> <br />Preporučujemo da koristite isključivo originalne rezervne dijelove. Korištenje neprovjerenih
                                dijelova može ugroziti sigurnost i funkcionalnost uređaja.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Nemojte mijenjati ili zloupotrebljavati uređaj:</strong> <br />Molimo vas da ne mijenjate uređaj ručno i da ga koristite samo u svrhe za koje je namijenjen.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Isključite uređaj iz električne mreže:</strong> <br />Ako je potrebna održavanje, pobrinite se da je uređaj potpuno isključen iz električne mreže kako biste
                                izbjegli električne opasnosti.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Slijedite upute u korisničkom priručniku:</strong> <br />Uvijek slijedite upute u korisničkom priručniku ili uputama proizvođača. Odluke koje odstupaju mogu
                                dovesti do nepravilnog rada ili sigurnosnih rizika.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p>
                                <strong>Kontaktirajte tehničku korisničku službu:</strong> <br />U slučaju sumnje ili problema s vašim uređajem, naša tehnička korisnička služba je dostupna za stručnu
                                pomoć.
                              </p>
                              <p>
                                <br />
                              </p>
                              <p><strong>Vaša odgovornost kao korisnika</strong></p>
                              <ul>
                                <li>Pažljivo pročitajte i razumite sve sigurnosne i upute za korištenje.</li>
                                <li>Koristite uređaj samo na način i u okruženju za koje je namijenjen.</li>
                                <li>Pohranite uređaj na sigurnom mjestu i izvan dohvata djece, osim ako nije izričito namijenjen njihovoj upotrebi.</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p><strong>Kontaktirajte našu korisničku službu</strong></p>
                              <p>Za podršku ili upite, uvijek smo vam na raspolaganju:</p>
                              <ul>
                                <li><strong>E-mail:</strong> kundenservice@kms-handel.de</li>
                                <li><strong>Telefon:</strong> +49 5921 81 999 - 0</li>
                              </ul>
                              <p>
                                <br />
                              </p>
                              <p>Vaše povjerenje je naša odgovornost. Zajedno s našim proizvodima i vašim sigurnim korištenjem, osiguravamo da možete uživati u visokokvalitetnoj zabavi bez brige.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <slot name="add-detail-tabs-content"></slot>
              </div>
            </div>
            <!-- ./ITEM DESCRIPTION -->

          </section>
          </div>

          <div class="kms-pdp__right">
            <aside class="kms-pdp__buybox">
              <div class="kms-pdp__buybox-inner" v-stick-in-parent>
              <!-- START SINGLEITEM_DETAILS -->
              <div class="producertag h6 producer text-muted" v-if="currentVariation.filter.hasManufacturer">
                {{ currentVariation.item.manufacturer.externalName }}
              </div>

              <h1 class="h2 title" data-testing="item-name">
                <span>
                  {{ currentVariation | itemName }}
                </span>
              </h1>

              <div class="single-description" v-if="isShortDescriptionActive && currentVariation.texts.shortDescription" v-html="currentVariation.texts.shortDescription"></div>

              <div class="kms-pdp__rating" :aria-label="$translate('KMSVueTheme::SingleItemTheme.RatingLabel')">
                <span class="kms-pdp__stars" aria-hidden="true">
                  <i class="fa fa-star" v-for="index in 5" :key="'rating-star-' + index"></i>
                </span>
                <span class="kms-pdp__rating-score">{{ $translate("KMSVueTheme::SingleItemTheme.RatingScore") }}</span>
                <span class="kms-pdp__rating-separator" aria-hidden="true">{{ $translate("KMSVueTheme::SingleItemTheme.RatingSeparator") }}</span>
                <span class="kms-pdp__rating-summary">{{ $translate("KMSVueTheme::SingleItemTheme.RatingSummary") }}</span>
              </div>

              <div class="kms-pdp__status-list">
                <div class="kms-pdp__availability">
                  <item-availability></item-availability>
                </div>
                <span v-if="freeShippingTag" class="kms-pdp__status-badge kms-pdp__free-shipping-badge">
                  {{ freeShippingTagLabel }}
                </span>
              </div>

              <!-- Variation -->
              <div class="mb-3" v-if="attributes.length || Object.keys(units).length">
                <variation-select></variation-select>
              </div>
              <!-- /Variation -->

              <!-- Item Bundle -->
              <item-bundle
                v-if="currentVariation.variation.bundleType === 'bundle'"
                :bundle-type="currentVariation.variation.bundleType"
                :bundle-components="currentVariation.bundleComponents"
              ></item-bundle>
              <!-- /Item Bundle -->

              <slot name="before-price"></slot>

              <div v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">
                <order-property-list></order-property-list>
              </div>

              <div class="kms-pdp__price-panel">
                <div class="kms-pdp__price-header">
                  <div class="kms-pdp__price-stack">
                    <graduated-prices></graduated-prices>

                    <item-price :show-cross-price="hasCrossPrice"></item-price>
                  </div>

                  <div v-if="hasCrossPrice" class="kms-pdp__sale-badge">
                    {{ $translate("KMSVueTheme::SingleItemTheme.SaleBadgePrefix") }}{{ saleBadgePercent }}%
                  </div>
                </div>

                <slot name="after-price"></slot>

                <span class="vat small text-muted kms-pdp__vat">
                  {{ $translate("Ceres::Template.singleItemFootnote1") }}
                  <template v-if="showNetPrices">{{ $translate("Ceres::Template.singleItemExclVAT") }}</template
                  ><template v-else>{{ $translate("Ceres::Template.singleItemInclVAT") }}</template>
                  {{ $translate("Ceres::Template.singleItemExclusive") }}
                  <a v-if="hasShippingCostsCategoryId" data-toggle="modal" href="#shippingscosts">{{ $translate("Ceres::Template.singleItemShippingCosts") }}</a>
                  <a v-else>{{ $translate("Ceres::Template.singleItemShippingCosts") }}</a>
                </span>

                <div class="kms-pdp__financing">
                  <button v-if="easycreditWidgetAvailable" type="button" class="kms-pdp__easycredit-button" data-ec-open>
                    <img
                      class="kms-pdp__easycredit-logo"
                      :src="$translate('KMSVueTheme::SingleItemTheme.EasyCreditLogoSrc')"
                      :alt="$translate('KMSVueTheme::SingleItemTheme.EasyCreditLogoAlt')"
                      loading="lazy"
                    />
                    <span class="kms-pdp__easycredit-copy">
                      <template v-if="easycreditRateLabel">
                        {{ $translate("KMSVueTheme::SingleItemTheme.EasyCreditPrefix") }}
                        <strong>{{ easycreditRateLabel }}</strong>
                        <span>{{ $translate("KMSVueTheme::SingleItemTheme.EasyCreditSuffix") }}</span>
                      </template>
                      <template v-else>
                        <strong>{{ $translate("KMSVueTheme::SingleItemTheme.EasyCreditFallback") }}</strong>
                      </template>
                    </span>
                    <span class="kms-pdp__easycredit-more" aria-hidden="true">+</span>
                  </button>
                  <div class="kms-pdp__easycredit-source" aria-hidden="true">
                    <slot name="before-add-to-basket"></slot>
                    <slot name="additional-content-after-vat"></slot>
                  </div>
                </div>
              </div>

              <div class="kms-pdp__purchase">
                <div v-if="currentVariation.item.itemType === 'set'" class="alert alert-info w-100">
                  {{ $translate("Ceres::Template.singleItemSetInfo") }}
                </div>
                <div v-else>
                  <div ref="buyboxCtaSentinel" aria-hidden="true"></div>
                  <div ref="buyboxCta" class="kms-pdp__action-row">
                    <add-to-basket
                      :variation-id="currentVariation.variation.id"
                      :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                      :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                      :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                      :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                      :maximum-quantity="
                        !!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null
                      "
                      :order-properties="
                        currentVariation.properties.filter(function(prop) {
                          return prop.property.isOderProperty;
                        })
                      "
                      :has-order-properties="currentVariation.hasOrderProperties"
                      :has-required-order-property="currentVariation.hasRequiredOrderProperty"
                      :use-large-scale="false"
                      :show-quantity="true"
                      :item-url="currentVariation | itemURL"
                      :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                      :has-price="currentVariation | hasItemDefaultPrice"
                    >
                    </add-to-basket>
                  </div>
                </div>

                <div class="kms-pdp__legacy-payment-banner">
                  <slot name="after-add-to-basket"></slot>
                </div>
              </div>

              <div v-if="isWishListEnabled" class="kms-pdp__wishlist">
                <add-to-wish-list
                  class="kms-pdp__wishlist-button"
                  :data-label="$translate('KMSVueTheme::SingleItemTheme.WishListLabel')"
                  :aria-label="$translate('KMSVueTheme::SingleItemTheme.WishListLabel')"
                  :variation-id="currentVariation.variation.id"
                ></add-to-wish-list>
              </div>
              <!-- ./ITEM DETAIL -->

              <div class="kms-pdp__submeta">
                <span class="articlenumber small text-muted">
                  <b>{{ $translate("Ceres::Template.singleItemNumber") }} </b>
                  <span>{{ currentVariation.variation.number }}</span>
                </span>
              </div>

              <div class="kms-pdp__post-purchase-plugin">
                <slot name="additional-content-after-add-to-basket"></slot>
              </div>

              <div class="kms-pdp__notice">
                <i class="fa fa-clock-o" aria-hidden="true"></i>
                <span>
                  <strong>{{ $translate("KMSVueTheme::SingleItemTheme.ScarcityNoticeStrong") }}</strong>
                  <span>{{ $translate("KMSVueTheme::SingleItemTheme.ScarcityNoticeText") }}</span>
                </span>
              </div>

              <div class="kms-pdp__service-grid">
                <div class="kms-pdp__service-card" v-for="benefit in serviceBenefits" :key="benefit.title">
                  <i class="fa kms-pdp__service-icon" :class="$translate(benefit.icon)" aria-hidden="true"></i>
                  <div>
                    <strong>{{ $translate(benefit.title) }}</strong>
                    <span>{{ $translate(benefit.text) }}</span>
                  </div>
                </div>
              </div>

              <div class="kms-pdp__payment-methods" :aria-label="$translate('KMSVueTheme::SingleItemTheme.PaymentMethodsLabel')">
                <a
                  v-for="method in paymentMethods"
                  :key="method.src"
                  class="kms-pdp__payment-link"
                  :href="$translate('KMSVueTheme::SingleItemTheme.PaymentMethodsLink')"
                >
                  <img class="kms-pdp__payment-logo" :src="$translate(method.src)" :alt="$translate(method.alt)" loading="lazy" />
                </a>
              </div>

              <a class="kms-pdp__service-package" :href="$translate('KMSVueTheme::SingleItemTheme.ServicePackageUrl')">
                <i class="fa fa-wrench kms-pdp__service-package-icon" aria-hidden="true"></i>
                <span class="kms-pdp__service-package-copy">
                  <strong>{{ $translate("KMSVueTheme::SingleItemTheme.ServicePackageTitle") }}</strong>
                  <span>{{ $translate("KMSVueTheme::SingleItemTheme.ServicePackageText") }}</span>
                  <span class="kms-pdp__service-package-link">{{ $translate("KMSVueTheme::SingleItemTheme.ServicePackageLinkText") }}</span>
                </span>
              </a>
              <!-- END SINGLEITEM_DETAILS -->
              </div>
            </aside>

            <slot name="cross-selling-sidebar"></slot>

            <!-- start YT integration -->
            <div v-if="currentVariation.variationProperties && currentVariation.variationProperties.length > 0" class="kms-pdp__video position-relative">
            <p v-if="hasVideo()" class="mb-3 d-block h4 font-weight-bold">
              {{ $translate("KMSVueTheme::SingleItemTheme.YoutubeHeadline") }}
            </p>
            <div v-for="(variationProperty, variationIndex) in currentVariation.variationProperties" :key="variationIndex">
              <div v-for="(property, index) in variationProperty.properties" :key="index" class="position-relative">
                <template v-if="property.id === 4">
                  <!-- Iframe -->
                  <div class="video-container">
                    <iframe
                      :class="{ 'blurred-video': !videoConsent }"
                      :src="'https://www.youtube-nocookie.com/embed/' + property.values.value"
                      frameborder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                    ></iframe>
                  </div>

                  <!-- Overlay für die Video-Einwilligung -->
                  <div v-if="!videoConsent" class="video-overlay d-flex align-items-center justify-content-center">
                    <div class="text-center text-white">
                      <p>
                        {{ $translate("KMSVueTheme::SingleItemTheme.OverlayText") }}
                      </p>
                      <button @click="showVideo" class="btn btn-primary mt-2">
                        {{ $translate("KMSVueTheme::SingleItemTheme.OverlayButtonText") }}
                      </button>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            </div>
            <!-- end YT integration -->
          </div>
        </div>

        <slot name="item-list-container"></slot>
        <slot name="feedback-container"></slot>

        <transition name="fs-sticky-cart-slide">
          <div class="fs-sticky-cart" v-if="showStickyCart" :aria-label="$translate('Ceres::Template.singleItemAddToBasket')">
            <div class="fs-sticky-cart__inner">
              <div class="fs-sticky-cart__thumb" aria-hidden="true">
                <div class="fs-sticky-discount d-flex align-items-center justify-content-center text-white font-weight-bold position-absolute" v-if="savingMoneyPercent > 0">
                  <span>-{{ savingMoneyPercent }}%</span>
                </div>
                <img
                  v-if="currentVariation.images && currentVariation.images.all && currentVariation.images.all.length"
                  :src="currentVariation.images.all[0].urlPreview || currentVariation.images.all[0].urlMiddle || currentVariation.images.all[0].url"
                  :alt="currentVariation | itemName"
                  loading="lazy"
                />
              </div>

              <div class="fs-sticky-cart__meta">
                <div class="fs-sticky-cart__title">{{ currentVariation | itemName }}</div>
                <div class="fs-sticky-cart__price">
                  <item-price :show-cross-price="false"></item-price>
                </div>
              </div>

              <div class="fs-sticky-cart__cta">
                <add-to-basket
                  :variation-id="currentVariation.variation.id"
                  :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                  :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                  :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                  :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                  :maximum-quantity="
                    !!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null
                  "
                  :order-properties="
                    currentVariation.properties.filter(function(prop) {
                      return prop.property.isOderProperty;
                    })
                  "
                  :has-order-properties="currentVariation.hasOrderProperties"
                  :has-required-order-property="currentVariation.hasRequiredOrderProperty"
                  :use-large-scale="false"
                  :show-quantity="false"
                  :item-url="currentVariation | itemURL"
                  :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                  :has-price="currentVariation | hasItemDefaultPrice"
                >
                </add-to-basket>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </slot>
  </div>
</template>

<script>
import { get } from "../../helper/get";
import { isNullOrUndefined } from "../../helper/utils";

export default {
  name: "single-item",

  props: {
    pleaseSelectOptionVariationId: {
      type: Number,
      default: 0,
    },
    initPleaseSelectOption: {
      type: Boolean,
      default: false,
    },
    showNetPrices: {
      type: Boolean,
      default: false,
    },
    isWishListEnabled: {
      type: Boolean,
      default: false,
    },
    itemId: {
      type: Number,
      required: true,
    },
    afterKey: Object,
  },

  jsonDataFields: ["itemData", "attributesData", "variations"],

  provide() {
    return {
      itemId: this.$props.itemId,
    };
  },

  computed: {
    serviceBenefits() {
      return [
        {
          icon: "KMSVueTheme::SingleItemTheme.ServiceBenefit1Icon",
          title: "KMSVueTheme::SingleItemTheme.ServiceBenefit1Title",
          text: "KMSVueTheme::SingleItemTheme.ServiceBenefit1Text",
        },
        {
          icon: "KMSVueTheme::SingleItemTheme.ServiceBenefit2Icon",
          title: "KMSVueTheme::SingleItemTheme.ServiceBenefit2Title",
          text: "KMSVueTheme::SingleItemTheme.ServiceBenefit2Text",
        },
        {
          icon: "KMSVueTheme::SingleItemTheme.ServiceBenefit3Icon",
          title: "KMSVueTheme::SingleItemTheme.ServiceBenefit3Title",
          text: "KMSVueTheme::SingleItemTheme.ServiceBenefit3Text",
        },
        {
          icon: "KMSVueTheme::SingleItemTheme.ServiceBenefit4Icon",
          title: "KMSVueTheme::SingleItemTheme.ServiceBenefit4Title",
          text: "KMSVueTheme::SingleItemTheme.ServiceBenefit4Text",
        },
      ];
    },

    paymentMethods() {
      return [
        {
          src: "KMSVueTheme::SingleItemTheme.PaymentMethodPayPalSrc",
          alt: "KMSVueTheme::SingleItemTheme.PaymentMethodPayPal",
        },
        {
          src: "KMSVueTheme::SingleItemTheme.PaymentMethodMastercardSrc",
          alt: "KMSVueTheme::SingleItemTheme.PaymentMethodMastercard",
        },
        {
          src: "KMSVueTheme::SingleItemTheme.PaymentMethodVisaSrc",
          alt: "KMSVueTheme::SingleItemTheme.PaymentMethodVisa",
        },
        {
          src: "KMSVueTheme::SingleItemTheme.PaymentMethodApplePaySrc",
          alt: "KMSVueTheme::SingleItemTheme.PaymentMethodApplePay",
        },
        {
          src: "KMSVueTheme::SingleItemTheme.PaymentMethodKlarnaSrc",
          alt: "KMSVueTheme::SingleItemTheme.PaymentMethodKlarna",
        },
      ];
    },

    canUseStickyCart() {
      const variation = this.currentVariation;

      return !!(variation && variation.filter && variation.filter.isSalable && variation.item && variation.item.itemType !== "set");
    },

    showStickyCart() {
      return this.canUseStickyCart && this.buyboxCtaAboveViewport && !this.buyboxCtaInView;
    },

    itemConfig() {
      return App.config.item.itemData;
    },

    isDescriptionTabActive() {
      return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all")) && !!this.currentVariation.texts.description.length;
    },

    currentVariationTags() {
      return this.currentVariation && Array.isArray(this.currentVariation.tags) ? this.currentVariation.tags : [];
    },

    productTags() {
      return this.currentVariationTags.filter(tag => this.isNoveltyTag(tag));
    },

    freeShippingTag() {
      return this.currentVariationTags.find(tag => this.isFreeShippingTag(tag));
    },

    freeShippingTagLabel() {
      return this.freeShippingTag ? this.getTagName(this.freeShippingTag) : this.$translate("KMSVueTheme::SingleItemTheme.FreeShippingLabel");
    },

    hasCrossPrice() {
      const prices = this.currentVariation && this.currentVariation.prices ? this.currentVariation.prices : {};
      const hasRrpPrice = !!prices.rrp && !!prices.default && prices.rrp.unitPrice.value > prices.default.unitPrice.value;
      const hasBeforePrice = !!prices.specialOffer && !!prices.default && prices.default.unitPrice.value > prices.specialOffer.unitPrice.value;

      return hasRrpPrice || hasBeforePrice;
    },

    saleBadgePercent() {
      return Math.max(1, this.savingMoneyPercent);
    },

    isManufacturerTabShown() {
      return (
        this.currentVariation.item.manufacturer.url !== "" ||
        this.currentVariation.item.manufacturer.street !== "" ||
        this.currentVariation.item.manufacturer.houseNo !== "" ||
        this.currentVariation.item.manufacturer.postcode !== "" ||
        this.currentVariation.item.manufacturer.town !== "" ||
        this.currentVariation.item.manufacturer.countryId !== 0 ||
        this.currentVariation.item.manufacturer.phoneNumber !== "" ||
        this.currentVariation.item.manufacturer.faxNumber !== "" ||
        this.currentVariation.item.manufacturer.email !== "" ||
        this.currentVariation.item.manufacturer.legalName !== "" ||
        this.currentVariation.item.manufacturer.contactUrl !== "" ||
        this.currentVariation.item.manufacturer.name !== "" ||
        this.currentVariation.item.manufacturer.externalName !== ""
      );
    },
    isEuResponsibleTabShown() {
      return (
        this.currentVariation.item.manufacturer.responsibleEmail !== "" ||
        this.currentVariation.item.manufacturer.responsibleHouseNo !== "" ||
        this.currentVariation.item.manufacturer.responsibleName !== "" ||
        this.currentVariation.item.manufacturer.responsiblePhoneNo !== "" ||
        this.currentVariation.item.manufacturer.responsiblePostCode !== "" ||
        this.currentVariation.item.manufacturer.responsibleStreet !== "" ||
        this.currentVariation.item.manufacturer.responsibleTown !== "" ||
        this.currentVariation.item.manufacturer.responsibleContactUrl !== "" ||
        this.currentVariation.item.manufacturer.responsibleCountry !== 0
      );
    },

    isShortDescriptionActive() {
      return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
    },

    hasShippingCostsCategoryId() {
      return App.config.global.shippingCostsCategoryId > 0;
    },

    isTechnicalDataTabActive() {
      return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all")) && !!this.currentVariation.texts.technicalData.length;
    },

    variationGroupedProperties() {
      return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
    },

    variationMissingProperties() {
      return this.$store.getters[`${this.itemId}/variationMissingProperties`];
    },

    currentVariation() {
      return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
    },

    isVariationSelected() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
    },

    attributes() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
    },

    units() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
    },

    isItemSet() {
      return this.$store.state.items.isItemSet;
    },

    savingMoneyPercent() {
      const prices = this.currentVariation && this.currentVariation.prices ? this.currentVariation.prices : {};
      let oldPrice = 0;
      let newPrice = 0;

      if (prices.specialOffer && prices.default) {
        oldPrice = prices.default.unitPrice.value;
        newPrice = prices.specialOffer.unitPrice.value;
      } else if (prices.rrp && prices.default) {
        oldPrice = prices.rrp.unitPrice.value;
        newPrice = prices.default.unitPrice.value;
      }

      if (oldPrice > 0 && newPrice > 0 && oldPrice > newPrice) {
        return Math.floor(((oldPrice - newPrice) / oldPrice) * 100);
      }

      return 0;
    },
  },

  created() {
    this.$store.dispatch("initVariation", this.itemData);
    this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
        itemId: this.itemId,
        attributes: this.attributesData,
        variations: this.variations,
        initialVariationId: this.currentVariation.variation.id,
        isPleaseSelectOption: this.initPleaseSelectOption,
        afterKey: this.afterKey,
      });

      if (this.isItemSet) {
        this.$store.dispatch("initSetComponents", this.itemData);
      }
    });

    // listen for variation change to hydrate all children lazy-hydrate components
    this.variationChangedHandler = () => {
      this.hydrateChildren(this.$children);
      this.queueEasycreditSync();
    };
    document.addEventListener("onVariationChanged", this.variationChangedHandler);
    this.initStickyCartTrigger();
    this.initEasycreditOpen();
  },

  beforeDestroy() {
    if (typeof document !== "undefined" && this.variationChangedHandler) {
      document.removeEventListener("onVariationChanged", this.variationChangedHandler);
      this.variationChangedHandler = null;
    }

    this.destroyStickyCartTrigger();
    this.destroyEasycreditOpen();
  },

  data() {
    return {
      videoConsent: false,
      buyboxCtaInView: true,
      buyboxCtaAboveViewport: false,
      stickyCartFallbackHandler: null,
      stickyCartFallbackRafId: null,
      variationChangedHandler: null,
      easycreditClickHandler: null,
      easycreditFallbackObserver: null,
      easycreditFallbackTimer: null,
      easycreditMutationObserver: null,
      easycreditSyncTimer: null,
      easycreditRateLabel: "",
      easycreditWidgetAvailable: false,
    };
  },
  methods: {
    getEasycreditWidget() {
      if (typeof document === "undefined") {
        return null;
      }

      return this.$el.querySelector("easycredit-widget") || document.querySelector("#easyCreditInformationWidget, easycredit-widget");
    },

    getEasycreditTrigger(widget) {
      if (!widget) {
        return null;
      }

      const selector = "button.ec-widget__link, button.ec-widget__cta, a.ec-widget__link, a.ec-widget__cta";

      const shadowTrigger = widget.shadowRoot ? widget.shadowRoot.querySelector(selector) : null;

      return shadowTrigger || widget.querySelector(selector);
    },

    syncEasycreditInfo() {
      const widget = this.getEasycreditWidget();
      const trigger = this.getEasycreditTrigger(widget);
      const shadowRate = widget && widget.shadowRoot ? widget.shadowRoot.querySelector(".ec-widget__link") : null;
      const rate = (shadowRate && shadowRate.textContent) || (trigger && trigger.textContent) || "";

      this.easycreditWidgetAvailable = !!trigger;
      this.easycreditRateLabel = rate.trim().replace(/\s+/g, " ");

      return !!trigger;
    },

    queueEasycreditSync() {
      if (typeof window === "undefined") {
        return;
      }

      window.clearTimeout(this.easycreditSyncTimer);
      this.easycreditSyncTimer = window.setTimeout(() => {
        this.syncEasycreditInfo();
      }, 250);
    },

    initEasycreditOpen() {
      if (typeof document === "undefined") {
        return;
      }

      const tryOpenEasyCredit = () => {
        const trigger = this.getEasycreditTrigger(this.getEasycreditWidget());

        if (!trigger) {
          return false;
        }

        trigger.click();
        return true;
      };

      this.easycreditClickHandler = (event) => {
        const trigger = event.target && event.target.closest ? event.target.closest("[data-ec-open]") : null;

        if (!trigger) {
          return;
        }

        event.preventDefault();

        if (tryOpenEasyCredit()) {
          return;
        }

        if (typeof MutationObserver === "undefined") {
          return;
        }

        if (this.easycreditFallbackObserver) {
          this.easycreditFallbackObserver.disconnect();
          this.easycreditFallbackObserver = null;
        }

        if (this.easycreditFallbackTimer) {
          window.clearTimeout(this.easycreditFallbackTimer);
          this.easycreditFallbackTimer = null;
        }

        this.easycreditFallbackObserver = new MutationObserver(() => {
          if (tryOpenEasyCredit() && this.easycreditFallbackObserver) {
            this.easycreditFallbackObserver.disconnect();
            this.easycreditFallbackObserver = null;

            if (this.easycreditFallbackTimer) {
              window.clearTimeout(this.easycreditFallbackTimer);
              this.easycreditFallbackTimer = null;
            }
          }
        });

        this.easycreditFallbackObserver.observe(document.documentElement, { childList: true, subtree: true });
        this.easycreditFallbackTimer = window.setTimeout(() => {
          if (this.easycreditFallbackObserver) {
            this.easycreditFallbackObserver.disconnect();
            this.easycreditFallbackObserver = null;
          }

          this.easycreditFallbackTimer = null;
        }, 3000);
      };

      this.$el.addEventListener("click", this.easycreditClickHandler);

      if (typeof MutationObserver === "undefined") {
        this.queueEasycreditSync();
        return;
      }

      this.easycreditMutationObserver = new MutationObserver(() => {
        if (this.syncEasycreditInfo()) {
          this.easycreditMutationObserver.disconnect();
          this.easycreditMutationObserver = null;
        }
      });
      this.easycreditMutationObserver.observe(document.documentElement, { childList: true, subtree: true });
      this.queueEasycreditSync();
    },

    destroyEasycreditOpen() {
      if (this.easycreditClickHandler && this.$el) {
        this.$el.removeEventListener("click", this.easycreditClickHandler);
        this.easycreditClickHandler = null;
      }

      if (this.easycreditFallbackObserver) {
        this.easycreditFallbackObserver.disconnect();
        this.easycreditFallbackObserver = null;
      }

      if (typeof window !== "undefined" && this.easycreditFallbackTimer) {
        window.clearTimeout(this.easycreditFallbackTimer);
        this.easycreditFallbackTimer = null;
      }

      if (this.easycreditMutationObserver) {
        this.easycreditMutationObserver.disconnect();
        this.easycreditMutationObserver = null;
      }

      if (typeof window !== "undefined" && this.easycreditSyncTimer) {
        window.clearTimeout(this.easycreditSyncTimer);
        this.easycreditSyncTimer = null;
      }
    },

    updateBuyboxViewportState() {
      if (typeof window === "undefined") {
        return;
      }

      const buyboxEl = this.$refs.buyboxCta;
      const sentinelEl = this.$refs.buyboxCtaSentinel;
      const triggerEl = sentinelEl || buyboxEl;

      if (!triggerEl) {
        return;
      }

      const targetRect = triggerEl.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      if (buyboxEl) {
        const buyboxRect = buyboxEl.getBoundingClientRect();
        this.buyboxCtaInView = buyboxRect.bottom > 0 && buyboxRect.top < viewportHeight;
      } else {
        this.buyboxCtaInView = targetRect.bottom > 0 && targetRect.top < viewportHeight;
      }

      this.buyboxCtaAboveViewport = targetRect.top <= 0;
    },

    initStickyCartTrigger() {
      if (typeof window === "undefined") {
        return;
      }

      const buyboxEl = this.$refs.buyboxCta;
      const sentinelEl = this.$refs.buyboxCtaSentinel;

      if (!buyboxEl && !sentinelEl) {
        return;
      }

      this.stickyCartFallbackHandler = () => {
        if (this.stickyCartFallbackRafId) {
          return;
        }

        this.stickyCartFallbackRafId = window.requestAnimationFrame(() => {
          this.stickyCartFallbackRafId = null;
          this.updateBuyboxViewportState();
        });
      };

      window.addEventListener("scroll", this.stickyCartFallbackHandler, { passive: true });
      window.addEventListener("resize", this.stickyCartFallbackHandler);
      window.addEventListener("orientationchange", this.stickyCartFallbackHandler);

      this.stickyCartFallbackHandler();
      window.setTimeout(() => this.updateBuyboxViewportState(), 0);
    },

    destroyStickyCartTrigger() {
      if (typeof window !== "undefined" && this.stickyCartFallbackHandler) {
        window.removeEventListener("scroll", this.stickyCartFallbackHandler);
        window.removeEventListener("resize", this.stickyCartFallbackHandler);
        window.removeEventListener("orientationchange", this.stickyCartFallbackHandler);
        this.stickyCartFallbackHandler = null;
      }

      if (typeof window !== "undefined" && this.stickyCartFallbackRafId) {
        window.cancelAnimationFrame(this.stickyCartFallbackRafId);
        this.stickyCartFallbackRafId = null;
      }
    },

    hasVideo() {
      return this.currentVariation.variationProperties.some((variationProperty) => variationProperty.properties.some((property) => property.id === 4));
    },

    getTagName(tag) {
      return (tag && tag.names && tag.names.name) || tag.name || "";
    },

    isFreeShippingTag(tag) {
      return this.normalizeTagName(this.getTagName(tag)).includes("versandkostenfrei");
    },

    isNoveltyTag(tag) {
      const normalizedName = this.normalizeTagName(this.getTagName(tag));

      return normalizedName === "neu" || normalizedName === "neuheit" || normalizedName === "new" || normalizedName === "newarrival" || normalizedName.includes("neuheit");
    },

    normalizeTagName(name) {
      return (name || "")
        .toString()
        .toLowerCase()
        .replace(/[\s_-]+/g, "");
    },

    showVideo() {
      this.videoConsent = true;
    },

    getDataField(field) {
      return get(this.currentVariation, field);
    },

    getFilteredDataField(field, filter) {
      if (!isNullOrUndefined(this.$options.filters[filter])) {
        return this.$options.filters[filter](this.getDataField(field));
      }

      return this.getDataField(field);
    },

    // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
    hydrateChildren(nodes) {
      nodes.forEach((component) => {
        if (component.$options.name === "lazy-hydrate") {
          component.hydrate();
        } else if (component.$children.length) {
          this.hydrateChildren(component.$children);
        }
      });
    },
  },
};
</script>
